(function () {
  'use strict';

  /* Multi-Key-Setup mit Random-Offset-Distribution.
     Pro Page-Load wird ein zufälliger Start-Offset gepickt → 5 parallele Brands
     verteilen sich über alle Keys statt alle auf Key 1+2 zu landen.
     Skaliert auf beliebig viele Keys — einfach Array erweitern. */
  var PSI_API_KEYS = [
    'AIzaSyCullnJi0ZpkE6Hobu8fygMuMubN1o9f_E', // Key 1
    'AIzaSyAYW4_3oQqKEdHf3Sq-xImqfnUZFme9qtw', // Key 2
    'AIzaSyDu5vodGQTJ2eEtcLe2bVoAec2CMBR1PB8'  // Key 3
  ].filter(function (k) { return !!k; });

  // Zufälliger Offset pro Page-Load → load distribution über mehrere Brands
  var KEY_OFFSET = PSI_API_KEYS.length ? Math.floor(Math.random() * PSI_API_KEYS.length) : 0;

  function pickKey(strategy) {
    if (!PSI_API_KEYS.length) return '';
    if (PSI_API_KEYS.length === 1) return PSI_API_KEYS[0];
    // Mobile = offset, Desktop = offset+1 (jeweils mod length) → immer 2 verschiedene Keys
    var idx = strategy === 'mobile' ? KEY_OFFSET : (KEY_OFFSET + 1) % PSI_API_KEYS.length;
    return PSI_API_KEYS[idx];
  }

  /* Category icon set — minimal line-style SVGs */
  var ICONS = {
    apps: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>',
    images: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>',
    theme: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3 7h7l-5.5 4 2 7.5L12 17l-6.5 3.5 2-7.5L2 9h7z"/></svg>',
    tracking: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3v18h18"/><path d="M7 14l3-3 4 4 5-6"/></svg>',
    infra: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/><circle cx="12" cy="12" r="3"/></svg>',
    mixed: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 3v9l6 3"/></svg>'
  };

  var SHOPIFY_AUDITS = {
    'render-blocking-resources': {
      title: 'Blockierende Scripts & Styles',
      plain: 'Scripts und Stylesheets, die den ersten Seitenaufbau blockieren. Dein User sieht weiße Seite, während Reviews, Popups, Klaviyo & Co. laden — genau in der Sekunde, in der der Kauf-Impuls entscheidet.',
      action: '1. **Scripts entkoppeln** — wir analysieren, welche Skripte den Seitenaufbau blockieren (Reviews, Popups, Chat, Tracking) und ziehen sie aus dem kritischen Pfad raus.\n2. **Tracking-Pixel migrieren** auf Shopify Customer Events — Meta, TikTok, GA4 laufen dann isoliert und blockieren dein Theme nicht mehr.\n3. **Reviews & Chat lazy-laden** — statt beim Seitenaufruf lädt das Widget erst, wenn es sichtbar wird oder der User interagiert.\n4. **Pop-Ups umbauen** auf Scroll-Tiefe oder Exit-Intent statt Page-Load-Trigger.',
      quickTip: 'Im Admin → Apps prüfen, welche Apps du wirklich aktiv nutzt. Jede unnötige App kostet Ladezeit — Deinstallation dauert 30 Sekunden.',
      difficulty: 'Medium', category: 'apps'
    },
    'unused-javascript': {
      title: 'Ungenutzter JavaScript-Code',
      plain: 'Apps laden JavaScript, das auf dieser Seite gar nicht verwendet wird. Die Homepage lädt Checkout-Skripte, die Produktseite lädt Account-Skripte — der User wartet auf Code, den er nie braucht.',
      action: '1. **Ruthless App-Audit** — wir schauen uns jede installierte App an und entfernen, was keinen messbaren Umsatz bringt.\n2. **Conditional Loading** einrichten: Checkout-Skripte laden nur im Checkout, Size-Charts nur auf Produktseiten, nicht überall.\n3. **Alte App-Reste entfernen** — viele Themes haben noch Script-Tags von Apps drin, die längst deinstalliert sind.\n4. **Theme-JS aufräumen** mit modernem Build — 30–50 % kleineres Bundle, gleiche Funktionalität.',
      quickTip: 'Admin → Apps durchgehen: welche 3 Apps bringen wirklich Umsatz? Der Rest raus. Das ist der schnellste Performance-Gewinn.',
      difficulty: 'Easy', category: 'apps'
    },
    'unused-css-rules': {
      title: 'Ungenutzte CSS-Regeln',
      plain: 'Dein Theme lädt CSS, das auf dieser Seite nie zum Einsatz kommt — oft alte Theme-Features oder Rückstände von deinstallierten Apps.',
      action: '1. **Critical CSS** — nur die Styles für den sichtbaren Bereich kommen direkt in den `<head>`, alles andere wird nachgeladen.\n2. **Route-spezifische Styles** — Produktseiten-CSS lädt nur auf Produktseiten, nicht überall.\n3. **Dead-CSS-Sweep** — wir scannen, welche Regeln auf keiner Seite jemals greifen, und entfernen sie.',
      difficulty: 'Medium', category: 'theme'
    },
    'modern-image-formats': {
      title: 'Alte Bildformate statt WebP/AVIF',
      plain: 'Deine Bilder werden als JPG/PNG ausgeliefert. Hero-Bild 800 KB statt 280 KB, Produktbilder 3× so groß wie nötig. Auf Mobile mit schwachem Netz: der Unterschied zwischen "schnell" und "weg".',
      action: '1. **WebP/AVIF-Umstellung** — moderne Bildformate sind 30–50 % kleiner bei identischer Qualität. Shopify kann das automatisch, wenn der richtige Filter gesetzt ist.\n2. **Responsive Bilder** — Mobile bekommt das 640px-Bild, Desktop das 1920px. Dein Theme prüfen wir Section für Section.\n3. **Hero-Image priorisieren** — wir setzen `fetchpriority="high"` + Preload im `<head>`, damit dein Hero nicht hinter CSS/Fonts in der Queue wartet.',
      quickTip: 'Admin → Files: Produktbilder, die du direkt hochlädst, vorher durch TinyPNG/Squoosh schicken. Spart 40–70 % Dateigröße ohne sichtbaren Qualitätsverlust.',
      difficulty: 'Easy', category: 'images'
    },
    'uses-optimized-images': {
      title: 'Bilder unzureichend komprimiert',
      plain: 'Deine Bilder sind zwar hochgeladen, aber nicht optimal komprimiert. 20–60% Dateigröße liegen oft brach.',
      action: 'Vor Upload: Tools wie TinyPNG oder Squoosh nutzen. Im Theme: `image_url` statt `img_url`, sinnvolle width-Parameter (nicht 2000px für ein 400px-Thumbnail).',
      difficulty: 'Easy', category: 'images'
    },
    'offscreen-images': {
      title: 'Bilder ohne Lazy-Loading',
      plain: 'Bilder außerhalb des sichtbaren Bereichs werden sofort geladen und stehlen Bandbreite vom Hero-Bild. Besonders fatal auf Kollektions-Seiten: dein User sieht Produkt 1-4 und zahlt fürs Laden von Produkt 50.',
      action: '1. **Lazy-Loading** für alle Bilder außer dem Hero — sie laden erst, wenn sie in Sicht kommen.\n2. **Hero-Image eager** mit `fetchpriority="high"` — NIE lazy auf dem wichtigsten Element.\n3. **Lange Produktlisten paginieren** — 20 pro Seite mit Load-More statt 60 auf einmal.',
      quickTip: 'Viele moderne Shopify-Themes haben "Lazy Loading" als Toggle im Theme-Editor. Check: Customize → Theme Settings → Images.',
      difficulty: 'Easy', category: 'images'
    },
    'properly-size-images': {
      title: 'Falsch dimensionierte Bilder',
      plain: 'Bilder werden in Desktop-Auflösung ausgeliefert und vom Mobile-Browser runtergerechnet. Mobile User laden dadurch oft 5× mehr als nötig.',
      action: '1. **Responsive-Srcset-Pipeline**: `image_tag` Filter mit 5-Step-Breakpoint-Set (320w/640w/960w/1280w/1920w) + context-spezifischen `sizes`-Deskriptoren.\n2. **Client-Hints-Header** (DPR, Viewport-Width, ECT) für perfektes Size-Matching auf Device-Level.\n3. **Art-Direction** via `<picture>` + `<source media="...">`: Mobile-Crop anders als Desktop (Quadrat vs. Landscape).\n4. **DPR-Cap auf 2×** statt 3× (keine sichtbare Qualitätsdiff, 40 % kleinere Assets).',
      difficulty: 'Medium', category: 'images'
    },
    'uses-responsive-images': {
      title: 'Fehlende Responsive Images (kein srcset)',
      plain: 'Dieselben Bilder auf Mobile und Desktop = Mobile lädt unnötig viel.',
      action: '1. **Migration zu `image_tag`-Filter** im kompletten Theme — Shopify generiert automatisch srcset + sizes.\n2. **Custom srcset** für Legacy-Bereiche: `{{ image | image_url: width: 320 }} 320w, {{ image | image_url: width: 640 }} 640w, ...`.\n3. **`sizes`-Attribut** pro Viewport-Context präzise setzen: `(max-width: 750px) 100vw, 50vw`.',
      difficulty: 'Medium', category: 'images'
    },
    'efficient-animated-content': {
      title: 'GIFs statt Video-Format',
      plain: 'GIFs sind grafisch ineffizient. Ein MP4/WebM ist bei gleicher Qualität 10–20× kleiner.',
      action: 'GIFs durch `<video autoplay muted loop playsinline>` mit MP4/WebM ersetzen. Für Pattern/UX-Effekte: CSS-Animationen nutzen.',
      difficulty: 'Medium', category: 'images'
    },
    'total-byte-weight': {
      title: 'Seitengröße insgesamt zu hoch',
      plain: 'Die Seite ist über 1,6 MB groß — das ist zu viel für Mobile mit schwacher Verbindung. Google-Empfehlung: unter 1 MB.',
      action: 'Drei Haupthebel: (1) Bilder optimieren + WebP. (2) Apps reduzieren. (3) Hero-Videos ersetzen durch Poster-Image + Play-on-Demand.',
      difficulty: 'Medium', category: 'mixed'
    },
    'server-response-time': {
      title: 'Langsame Server-Antwort',
      plain: 'Shopify braucht zu lange, um dein HTML zu generieren. Ziel: unter 500 ms. Deiner ist drüber. Ursachen sind meist komplexe Theme-Logik oder schwere Apps, die im Hintergrund mitrechnen.',
      action: '1. **Liquid-Profiling** — wir messen, welche Template-Bereiche wie lange brauchen, und optimieren gezielt die Hotspots.\n2. **Metafield-Aufräumen** — viele Themes laden Dutzende Metafields pro Seite, die niemand braucht. Rausnehmen bringt 100–300 ms.\n3. **Heavy Apps identifizieren** — Apps wie Loox oder Yotpo machen Live-API-Calls während des Server-Rendering. Wir verschieben das auf den Client.\n4. **Aggressive Caching** für statische Bereiche einrichten.',
      difficulty: 'Hard', category: 'theme'
    },
    'dom-size': {
      title: 'Zu viele DOM-Elemente',
      plain: 'Über 1.500 DOM-Elemente machen Rendering und JS-Interaktion langsam.',
      action: '1. **Virtualized Lists** für Collection-Grids: nur sichtbare Items rendern, Rest via `IntersectionObserver`-Recycling-Pattern.\n2. **Cursor-Pagination** statt komplette Produkt-Dumps: First-Load 20 Items, Load-More via Section-Rendering-API.\n3. **Wrapper-Elimination**: verschachtelte Divs in Sections flatten — oft 3–4 Layer Wrapper pro Card reduzierbar ohne visuelle Änderung.\n4. **CSS Container Queries** statt JS-Breakpoint-Logic — reduziert DOM-Komplexität und Script-Gewicht.\n5. **`content-visibility: auto`** auf Off-Screen-Sections: Browser rendert nur Viewport, DOM-Size-Penalty entfällt.',
      difficulty: 'Medium', category: 'theme'
    },
    'mainthread-work-breakdown': {
      title: 'Überlasteter Main Thread',
      plain: 'JavaScript blockiert den Browser so sehr, dass User-Interaktionen träge werden — Tap, Scroll, Wischen hängen kurz. Besonders auf Mobile fühlt sich das sofort kaputt an.',
      action: '1. **Long Tasks identifizieren** — Skripte, die den Browser länger als 50 ms blockieren, splitten wir auf oder entfernen sie.\n2. **Tracking-Scripts** in isolierte Worker-Sandbox verschieben — Main Thread bleibt frei für User-Interaktion.\n3. **Schwere Features** (Produkt-Zoom, Filter, Sort) auf Web Worker auslagern, damit UI smooth bleibt.',
      difficulty: 'Medium', category: 'tracking'
    },
    'bootup-time': {
      title: 'Lange JS-Startzeit',
      plain: 'JavaScript braucht zu lange, um zu parsen und zu starten — verzögert alle Interaktionen.',
      action: '1. **Bundle-Size-Budget**: Main-Bundle <50 KB gzipped, per Lighthouse-CI gatekeeped im Deployment.\n2. **Modern-JS-Output**: Build-Target `esnext` statt `es5` (kein Polyfill-Bloat); via `<script type="module">` für moderne Browser + `nomodule` Fallback.\n3. **Parser-Blocking-Reduction**: Third-Party-Scripts mit `async`/`defer`, kritische First-Party-Scripts inline und minified.\n4. **HTTP/2 Push → 103 Early Hints** Migration: Resources werden schon vor dem HTML-Response negotiated.\n5. **Self-Hosting Google-Fonts + Analytics** via Shopify Assets: eliminiert 2 DNS-Lookups + TLS-Handshakes.',
      difficulty: 'Medium', category: 'apps'
    },
    'third-party-summary': {
      title: 'Third-Party Scripts dominieren',
      plain: 'Externe Scripts (Meta Pixel, TikTok, Klaviyo, GA4, Chat, Reviews) fressen den größten Anteil deiner Performance. Jeder externe Anbieter kostet DNS-Lookup + Download + Parsing.',
      action: '1. **Tracking-Pixel konsolidieren** — alle (Meta, TikTok, GA4, Pinterest) über Shopify Customer Events. Null Blocking + verlässliche Server-Side-Events.\n2. **Resource-Hints** setzen — Browser löst externe Domains schon auf, bevor sie gebraucht werden.\n3. **Reviews & Chat lazy** — erst bei User-Intent laden, nicht beim Seitenaufruf.',
      quickTip: 'Shopify Admin → Settings → Customer events. Dort kannst du Meta Pixel, GA4 & Co. einrichten — blockiert dein Theme nicht mehr.',
      difficulty: 'Medium', category: 'tracking'
    },
    'font-display': {
      title: 'Unsichtbarer Text während Font-Load',
      plain: 'Dein Text ist unsichtbar, während Webfonts laden (FOIT). Der User starrt auf eine leere Seite.',
      action: '1. **`font-display: swap`** auf allen `@font-face`-Rules — oder `optional` für LCP-kritische Fonts (kein FOUT-Flash).\n2. **Font-Subsetting** mit `unicode-range`: nur tatsächlich genutzte Glyphen (Latin-Subset statt Full-Unicode) — 60–80 % kleinere Font-Files.\n3. **Fallback-Matching** via `size-adjust`/`ascent-override`/`descent-override`: System-Font matched Web-Font Pixel-genau, CLS = 0 bei Swap.\n4. **Preload** mit `crossorigin` für kritische Fonts: `<link rel="preload" as="font" type="font/woff2" crossorigin>`.\n5. **WOFF2-only** + Brotli-Server-Compression — WOFF1/TTF entfernen.',
      difficulty: 'Easy', category: 'theme'
    },
    'uses-rel-preconnect': {
      title: 'Fehlende Preconnect-Hints',
      plain: 'Externe Domains werden erst aufgelöst, wenn das erste Asset von dort angefordert wird — kostet 100–300ms pro Domain.',
      action: '1. **Resource-Hints-Cascade** im `<head>`: `preconnect` für CDN + Tier-1-Origins (Meta-Pixel, Shopify-CDN), `dns-prefetch` für Tier-2 (Analytics, Reviews).\n2. **`crossorigin`-Attribut** korrekt setzen für CORS-geschützte Fonts/APIs — sonst öffnet Browser doppelte Connection.\n3. **Max 6–8 Preconnects** (Browser-Limit für Parallel-Connections), darüber hinaus nur `dns-prefetch` verwenden.\n4. **Self-Hosting** für Google Fonts + Analytics: eliminiert Preconnect-Bedarf komplett.',
      difficulty: 'Easy', category: 'theme'
    },
    'redirects': {
      title: 'Unnötige Weiterleitungen',
      plain: 'Jede Weiterleitung kostet 100–500ms. HTTP→HTTPS, www→non-www, Sprachversionen-Redirects etc.',
      action: 'Sicherstellen, dass alle internen Links direkt auf HTTPS + korrekten Hostnamen zeigen. In /admin/redirects alte Redirect-Ketten aufräumen.',
      difficulty: 'Easy', category: 'infra'
    },
    'largest-contentful-paint-element': {
      title: 'LCP-Element lädt zu spät',
      plain: 'Dein Largest Contentful Paint — meistens Hero-Bild oder große Headline — braucht zu lange, um sichtbar zu werden. Das ist der Moment, in dem der User entscheidet, ob er bleibt.',
      action: '1. **Hero-Preload** — der Browser lädt dein Hero-Bild VOR allen anderen Assets.\n2. **Critical CSS inline** — der Browser braucht keine externe CSS-Datei, um den Hero zu zeichnen.\n3. **`fetchpriority="high"`** auf dem Hero-Bild — überholt andere Requests in der Ladereihenfolge.',
      difficulty: 'Medium', category: 'images'
    },
    'cumulative-layout-shift': {
      title: 'Springendes Layout',
      plain: 'Elemente verschieben sich während des Ladens. Der User will "In den Warenkorb" klicken, trifft aber versehentlich "Favoriten" — oder noch schlimmer, den Cookie-Banner. Conversion-Rate-Killer #1 auf Mobile.',
      action: '1. **Bild-Dimensionen setzen** — alle Bilder bekommen Width/Height, damit der Browser Platz reserviert, bevor sie geladen sind.\n2. **Font-Matching** — der Fallback-Font passt in der Größe zum Web-Font, kein Umbruch beim Swap.\n3. **Cookie-Banner & Pop-Ups** als Overlay statt Push-Down — bewegen nichts, was darunter liegt.\n4. **Dynamische Widgets** mit Skeleton-Placeholder, der die Endgröße vorwegnimmt.',
      difficulty: 'Medium', category: 'theme'
    },
    'non-composited-animations': {
      title: 'Ruckelige Animationen',
      plain: 'CSS-Animationen laufen auf der CPU statt GPU. Besonders Mobile ruckelt dadurch sichtbar.',
      action: 'Nur GPU-beschleunigte Properties animieren: `transform` und `opacity`. Nicht: `width`, `height`, `top`, `left`.',
      difficulty: 'Medium', category: 'theme'
    },
    'duplicated-javascript': {
      title: 'Doppelt geladener JS-Code',
      plain: 'Die gleiche Library wird mehrfach geladen (z.B. jQuery vom Theme UND von einer App).',
      action: 'App-Scripts untersuchen: bringen Apps ihre eigene Library-Version mit, obwohl das Theme sie schon hat?',
      difficulty: 'Medium', category: 'apps'
    },
    'legacy-javascript': {
      title: 'Legacy JavaScript',
      plain: 'Code wird für alte Browser transpiliert und ist dadurch 30–50% größer als nötig.',
      action: 'Bei Custom-Theme-JS: moderne Build-Target-Config (nur Browser ab 2020).',
      difficulty: 'Hard', category: 'theme'
    },
    'prioritize-lcp-image': {
      title: 'LCP-Bild nicht priorisiert',
      plain: 'Dein wichtigstes Bild (sichtbar beim Seitenaufruf) wird vom Browser nicht bevorzugt geladen.',
      action: 'Auf LCP-Bild: `fetchpriority="high"` Attribut. Zusätzlich preload-Hint im head.',
      difficulty: 'Easy', category: 'images'
    },
    'uses-text-compression': {
      title: 'Text-Kompression fehlt',
      plain: 'HTML/CSS/JS wird ohne gzip/brotli ausgeliefert — bis zu 70% mehr Bytes als nötig.',
      action: 'Shopify-CDN macht das automatisch. Wenn der Audit trotzdem fehlschlägt: externe CDN-Assets (bei Apps) prüfen.',
      difficulty: 'Hard', category: 'infra'
    },
    'uses-long-cache-ttl': {
      title: 'Kurze Cache-Zeiten',
      plain: 'Statische Assets werden öfter neu geladen als nötig.',
      action: 'Shopify-Assets werden bereits lang gecached. Problem liegt meist bei externen Assets — Anbieter um längere Cache-TTL bitten.',
      difficulty: 'Hard', category: 'infra'
    }
  };

  var CATEGORY_LABELS = {
    apps: 'Apps',
    images: 'Bilder',
    theme: 'Theme',
    tracking: 'Tracking',
    infra: 'Infrastruktur',
    mixed: 'Gemischt'
  };

  /* Schätzung: viele Lighthouse-Audits liefern kein overallSavingsMs (z.B. dom-size,
     third-party-summary, mainthread-work-breakdown). Damit der Gesamt-Hebel-Wert nicht
     nur die wenigen quantifizierbaren Audits reflektiert, schätzen wir konservativ
     anhand der Metric-Gaps zu den "Good"-Schwellwerten. Cap pro Audit verhindert,
     dass eine einzelne Karte den Total dominiert. */
  function estimateAuditSavingsMs(auditId, metrics) {
    var lcpGap = Math.max(0, (metrics.lcp || 0) - 2500);
    var fcpGap = Math.max(0, (metrics.fcp || 0) - 1800);
    var tbtGap = Math.max(0, (metrics.tbt || 0) - 200);
    var raw;
    switch (auditId) {
      case 'dom-size':                         raw = lcpGap * 0.18 + tbtGap * 0.15 + 80;  return Math.min(700, raw);
      case 'third-party-summary':              raw = lcpGap * 0.30 + tbtGap * 0.40 + 150; return Math.min(1200, raw);
      case 'mainthread-work-breakdown':        raw = tbtGap * 0.50 + 100;                 return Math.min(900, raw);
      case 'bootup-time':                      raw = tbtGap * 0.35 + fcpGap * 0.15 + 80;  return Math.min(700, raw);
      case 'font-display':                     raw = fcpGap * 0.18 + 180;                 return Math.min(450, raw);
      case 'largest-contentful-paint-element': raw = lcpGap * 0.35 + 100;                 return Math.min(900, raw);
      case 'prioritize-lcp-image':             raw = lcpGap * 0.28 + 80;                  return Math.min(700, raw);
      case 'non-composited-animations':        raw = tbtGap * 0.10 + 100;                 return Math.min(280, raw);
      case 'legacy-javascript':                raw = tbtGap * 0.18 + 60;                  return Math.min(450, raw);
      case 'duplicated-javascript':            raw = tbtGap * 0.14 + 50;                  return Math.min(350, raw);
      case 'uses-text-compression':            raw = lcpGap * 0.10 + 50;                  return Math.min(350, raw);
      /* CLS ist unitless, uses-long-cache-ttl betrifft nur Repeat-Visits → keine LCP-Wirkung */
      case 'cumulative-layout-shift':
      case 'uses-long-cache-ttl':
      default:
        return 0;
    }
  }

  var LOADING_FACTS = [
    '53% der Mobile-User brechen ab, wenn eine Seite länger als 3 Sekunden lädt. — Google',
    'Amazon verliert 1% Umsatz pro 100ms zusätzlicher Ladezeit. — Amazon',
    'Walmart steigerte Conversion um 2% pro 1 Sekunde schnellerer Ladezeit. — Walmart',
    'Vodafone: 31% schnelleres LCP führten zu 8% mehr Sales. — Google Case Study',
    '0,1 Sekunden schnellere Ladezeit = 8,4% mehr Conversion im Retail. — Deloitte 2020',
    'Pinterest reduzierte Wartezeit um 40% und steigerte SEO-Traffic um 15%. — Pinterest Engineering',
    'Bei Shopify-Shops gehen ~40% der Performance-Probleme auf Apps zurück.',
    'Das teuerste Element eines Shops ist oft das, was der Kunde nie sieht — blockierendes JavaScript.'
  ];

  /* Terminal-style log messages — split into 3 phases:
     PROGRESS runs during PSI fetch, FILLERS loop while we wait for Google,
     FINALIZE drains only AFTER PSI actually returns. Prevents [DONE] showing
     before the analysis is real-done. */
  var LOG_PROGRESS = [
    { tag: 'INIT', msg: 'establishing connection to pagespeedinsights.googleapis.com' },
    { tag: 'HTTPS', msg: 'tls handshake complete · tls 1.3' },
    { tag: 'SCAN', msg: 'dispatching mobile lighthouse audit · emulated moto g power' },
    { tag: 'SCAN', msg: 'collecting core web vitals · lcp, cls, inp, tbt, fcp' },
    { tag: 'TRACE', msg: 'analyzing network waterfall · third-party scripts · render-blocking resources' },
    { tag: 'TRACE', msg: 'inspecting dom tree · asset manifest · javascript bundles' },
    { tag: 'SCAN', msg: 'dispatching desktop lighthouse audit · emulated chrome desktop' }
  ];

  var LOG_FILLERS = [
    { tag: 'WAIT', msg: 'lighthouse rendering page in headless chrome · this is the slow part' },
    { tag: 'WAIT', msg: 'measuring lcp · waiting for stable layout' },
    { tag: 'TRACE', msg: 'monitoring main-thread blocking · javascript execution time' },
    { tag: 'WAIT', msg: 'collecting field data from chrome ux report · last 28 days' },
    { tag: 'TRACE', msg: 'profiling third-party requests · cookie banners · analytics tags' },
    { tag: 'NET', msg: 'measuring network waterfall · request priorities · dependency chain' },
    { tag: 'AUDIT', msg: 'evaluating render-blocking css · stylesheet priorities' },
    { tag: 'CHECK', msg: 'inspecting image formats · webp / avif coverage · lazy loading' },
    { tag: 'TRACE', msg: 'recording cumulative layout shift · cls candidates flagged' },
    { tag: 'MEASURE', msg: 'first contentful paint timing · paint events captured' },
    { tag: 'WAIT', msg: 'simulating throttled 4g network · 1.6mbps · 150ms rtt' },
    { tag: 'AUDIT', msg: 'checking compression headers · gzip / brotli · cache-control' },
    { tag: 'TRACE', msg: 'analyzing dom complexity · counting nodes · depth profile' },
    { tag: 'NET', msg: 'sniffing critical request chain · longest path detection' },
    { tag: 'CHECK', msg: 'evaluating font-display strategy · woff2 preload hints' },
    { tag: 'WAIT', msg: 'awaiting interaction-to-next-paint sample · inp metric' },
    { tag: 'AUDIT', msg: 'scanning for unused javascript · dead-code coverage' },
    { tag: 'TRACE', msg: 'measuring time-to-interactive · main-thread idle search' },
    { tag: 'CHECK', msg: 'evaluating service worker · cache strategies · offline support' },
    { tag: 'WAIT', msg: 'lighthouse re-running audit pass · stabilizing metrics' }
  ];

  var LOG_FINALIZE = [
    { tag: 'OK', msg: 'audits complete · compiling lighthouse report' },
    { tag: 'PARSE', msg: 'translating audit ids to shopify-specific context' },
    { tag: 'PARSE', msg: 'cross-referencing 25+ known shopify performance patterns' },
    { tag: 'CALC', msg: 'computing revenue impact based on deloitte conversion-lift model' },
    { tag: 'DONE', msg: 'report assembled · rendering insights' }
  ];

  /* Common disposable / throwaway email domains — blocked at gate.
     Curated list of high-volume offenders; not exhaustive but catches ~95% of junk. */
  var DISPOSABLE_EMAIL_DOMAINS = {
    'mailinator.com': 1, 'mailinator.net': 1, 'mailinator2.com': 1,
    'guerrillamail.com': 1, 'guerrillamail.net': 1, 'guerrillamail.org': 1, 'guerrillamail.biz': 1, 'guerrillamail.de': 1,
    'sharklasers.com': 1, 'grr.la': 1, 'guerrillamailblock.com': 1,
    '10minutemail.com': 1, '10minutemail.net': 1, '10minutemail.org': 1, '10minemail.com': 1, '10minutemail.de': 1,
    'tempmail.com': 1, 'tempmail.io': 1, 'tempmail.dev': 1, 'tempmail.net': 1, 'tempmail.us.com': 1,
    'temp-mail.org': 1, 'temp-mail.io': 1, 'temp-mail.com': 1,
    'tempmailo.com': 1, 'tempail.com': 1, 'tempinbox.com': 1, 'mytemp.email': 1,
    'temporarymail.com': 1, 'temporary-mail.net': 1,
    'yopmail.com': 1, 'yopmail.net': 1, 'yopmail.fr': 1, 'yopmail.de': 1,
    'throwawaymail.com': 1, 'throwaway.email': 1, 'throwam.com': 1,
    'fakeinbox.com': 1, 'fakemail.com': 1, 'fakemailgenerator.com': 1, 'fake-mail.net': 1,
    'maildrop.cc': 1, 'mailcatch.com': 1, 'mailnesia.com': 1, 'mailtothis.com': 1,
    'getairmail.com': 1, 'getnada.com': 1, 'nada.email': 1,
    'mintemail.com': 1, 'mohmal.com': 1, 'spamgourmet.com': 1, 'dispostable.com': 1,
    'spambox.us': 1, 'spam4.me': 1, 'spamfree24.com': 1, 'spamfree24.org': 1,
    'einrot.com': 1, 'einrot.de': 1,
    'wegwerfemail.de': 1, 'wegwerfmail.de': 1, 'wegwerf-email.de': 1,
    'trashmail.com': 1, 'trashmail.de': 1, 'trashmail.net': 1, 'trashmail.io': 1, 'trashmail.org': 1,
    'tempr.email': 1, 'discard.email': 1, 'discardmail.com': 1,
    'emailondeck.com': 1, 'inboxbear.com': 1, 'minutemail.com': 1, 'mt2014.com': 1,
    'mvrht.com': 1, 'mvrht.net': 1, 'mailsac.com': 1,
    'spambog.com': 1, 'spambog.de': 1, 'jetable.org': 1, 'jetable.com': 1,
    'mail-temporaire.fr': 1, 'mail-temporaire.com': 1,
    'pokemail.net': 1, 'spam.la': 1, 'kiani.com': 1,
    'bareed.ws': 1, 'mailforspam.com': 1, 'mailexpire.com': 1,
    'mytrashmail.com': 1, 'fastmazda.com': 1, 'h.mintemail.com': 1
  };

  function SpeedTest(root) {
    this.root = root;
    this.form = root.querySelector('[data-stf-form]');
    this.urlInput = root.querySelector('[data-stf-url]');
    this.submitBtn = root.querySelector('[data-stf-submit]');
    this.loading = root.querySelector('[data-stf-loading]');
    this.results = root.querySelector('[data-stf-results]');
    this.error = root.querySelector('[data-stf-error]');
    this.hero = root.querySelector('[data-stf-hero]');
    this.percentEl = root.querySelector('[data-stf-percent]');
    this.loadingIdEl = root.querySelector('[data-stf-loading-id]');
    this.loadingUrlEl = root.querySelector('[data-stf-loading-url]');
    this.stepsEl = root.querySelector('[data-stf-steps]');
    this.radarProgress = root.querySelector('.stf-radar-progress');
    this.logEl = root.querySelector('[data-stf-log]');
    this.factEl = root.querySelector('[data-stf-fact]');
    this.patienceEl = root.querySelector('[data-stf-patience]');
    this.patienceTextEl = root.querySelector('[data-stf-patience-text]');
    this.ctaData = {
      eyebrow: root.dataset.ctaEyebrow || '',
      headline: root.dataset.ctaHeadline || '',
      buttonText: root.dataset.ctaButtonText || '',
      buttonUrl: (root.dataset.ctaButtonUrl || '').trim(),
      calendlyUrl: (root.dataset.ctaCalendlyUrl || '').trim(),
      subtext: root.dataset.ctaSubtext || ''
    };
    this.defaults = {
      revenue: parseFloat(root.dataset.defaultRevenue) || 50000,
      convRate: parseFloat(root.dataset.defaultConvRate) || 2.0
    };
    this.gateConfig = {
      enabled: root.dataset.gateEnabled === 'true',
      headline: root.dataset.gateHeadline || 'Vollständige Analyse freischalten',
      subtext: root.dataset.gateSubtext || '',
      placeholder: root.dataset.gatePlaceholder || 'deine@email.de',
      phonePlaceholder: root.dataset.gatePhonePlaceholder || 'z.B. 0151 12345678 oder +43 664 1234567',
      button: root.dataset.gateButton || 'Ergebnisse anzeigen',
      trust: root.dataset.gateTrust || '',
      webhook: root.dataset.gateWebhook || '',
      publicTestWebhook: root.dataset.publicTestWebhook || '',
      klaviyoKey: root.dataset.klaviyoKey || '',
      klaviyoList: root.dataset.klaviyoList || '',
      klaviyoEvent: root.dataset.klaviyoEvent || 'Speed Test Submitted',
      metaPixelId: root.dataset.metaPixelId || '',
      metaTestCode: root.dataset.metaTestCode || ''
    };
    if (this.gateConfig.metaPixelId) this.initMetaPixel();
    this._progress = 0;
    this.baitConfig = {
      enabled: root.dataset.baitEnabled !== 'false',
      adspendThreshold: root.dataset.baitAdspendThreshold || '30K'
    };
    this.bind();
    if (this.baitConfig.enabled) this.initBait();
  }

  SpeedTest.prototype.bind = function () {
    var self = this;
    this.form.addEventListener('submit', function (e) { e.preventDefault(); self.run(); });
    var retry = this.root.querySelector('[data-stf-retry]');
    if (retry) retry.addEventListener('click', function () { self.reset(); });
  };

  SpeedTest.prototype.reset = function () {
    this.error.hidden = true;
    this.loading.hidden = true;
    this.results.hidden = true;
    this.hero.hidden = false;
    this.submitBtn.disabled = false;
    this.setProgress(0);
    if (this.logEl) this.logEl.innerHTML = '';
    clearTimeout(this._gateTimer);
    clearTimeout(this._gateFallbackTimer);
    this.stopPatienceEscalation();
    if (this._gateObserver) { this._gateObserver.disconnect(); this._gateObserver = null; }
    document.body.style.overflow = '';
  };

  SpeedTest.prototype.normalizeUrl = function (raw) {
    if (!raw) return null;
    var url = raw.trim().replace(/^https?:\/\//i, '').replace(/\/$/, '');
    if (!url || url.indexOf('.') === -1) return null;
    return 'https://' + url;
  };

  SpeedTest.prototype.genId = function () {
    var n = Math.floor(Math.random() * 9000) + 1000;
    return 'SPD-' + n;
  };

  SpeedTest.prototype.run = function () {
    var self = this;
    var url = this.normalizeUrl(this.urlInput.value);
    if (!url) {
      this.showError('Bitte gib eine gültige URL ein (z.B. deinshop.de).');
      return;
    }
    // ViewContent: Test wurde gestartet (URL eingetragen + abgeschickt)
    this.fireViewContent(url);
    this.hero.hidden = true;
    this.error.hidden = true;
    this.results.hidden = true;
    this.loading.hidden = false;
    if (this.loadingUrlEl) this.loadingUrlEl.textContent = url;
    if (this.loadingIdEl) this.loadingIdEl.textContent = this.genId();
    if (this.logEl) this.logEl.innerHTML = '';
    this.rotateFact();
    this.startProgressAnimation();
    this.startLogStream();
    this.startPatienceEscalation();

    (async function () {
      var stepTimers = [];
      try {
        self.setStep('connect');
        await self.wait(600);
        self.setStep('mobile');
        // Visual-Step: Desktop nach ~10s als "active" markieren — auch wenn
        // er parallel zu Mobile schon läuft. Reine UI-Optik für den User.
        stepTimers.push(setTimeout(function () { self.setStep('desktop'); }, 10000));
        // PARALLEL: Mobile (Key 1) + Desktop (Key 2) gleichzeitig.
        // Halbiert die Wartezeit für den Händler vs. sequentiell.
        var both = await Promise.all([
          self.fetchPSI(url, 'mobile'),
          self.fetchPSI(url, 'desktop')
        ]);
        // PSI ist jetzt real fertig — Log auf Finalize-Sequenz umschalten,
        // damit [DONE] erst jetzt rauskommt (nicht mehr fake nach 22s).
        self.finalizeLogStream();
        var mobile = both[0];
        var desktop = both[1];
        stepTimers.forEach(clearTimeout);
        self.setStep('interpret');
        await self.wait(800);
        self.setStep('impact');
        await self.wait(500);
        self.stopProgressAnimation(100);
        await self.wait(400);
        self.render({ mobile: mobile, desktop: desktop, url: url });
      } catch (e) {
        stepTimers.forEach(clearTimeout);
        console.error('[SpeedTest]', e);
        self.stopLogStream();
        self.showError(e.message || 'Die Analyse konnte nicht abgeschlossen werden.');
      }
    })();
  };

  SpeedTest.prototype.wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

  SpeedTest.prototype.emitLogLine = function (tag, msg) {
    if (!this.logEl) return;
    var time = new Date();
    var timeStr = String(time.getSeconds()).padStart(2, '0') + '.' + String(time.getMilliseconds()).padStart(3, '0').slice(0, 3);
    var line = document.createElement('div');
    line.className = 'stf-log-line';
    line.innerHTML =
      '<span class="stf-log-time">' + timeStr + '</span>' +
      '<span class="stf-log-tag">[' + tag + ']</span>' +
      '<span class="stf-log-msg">' + this.escape(msg) + '</span>';
    this.logEl.appendChild(line);
    while (this.logEl.children.length > 5) this.logEl.removeChild(this.logEl.firstChild);
  };

  SpeedTest.prototype.startLogStream = function () {
    var self = this;
    if (!this.logEl) return;
    var progressIdx = 0;
    var fillerIdx = 0;
    self.emitLogLine(LOG_PROGRESS[0].tag, LOG_PROGRESS[0].msg);
    progressIdx = 1;
    this._logInterval = setInterval(function () {
      if (progressIdx < LOG_PROGRESS.length) {
        var m = LOG_PROGRESS[progressIdx++];
        self.emitLogLine(m.tag, m.msg);
      } else {
        // PSI noch am Rendern — Filler-Loop bis finalizeLogStream() called wird
        var f = LOG_FILLERS[fillerIdx % LOG_FILLERS.length];
        fillerIdx++;
        self.emitLogLine(f.tag, f.msg);
      }
    }, 1800);
  };

  SpeedTest.prototype.finalizeLogStream = function () {
    var self = this;
    clearInterval(this._logInterval);
    this._logInterval = null;
    if (!this.logEl) return;
    var i = 0;
    var emitNext = function () {
      if (i >= LOG_FINALIZE.length) return;
      var m = LOG_FINALIZE[i++];
      self.emitLogLine(m.tag, m.msg);
      if (i < LOG_FINALIZE.length) {
        self._logFinalizeTimer = setTimeout(emitNext, 500);
      }
    };
    emitNext();
  };

  SpeedTest.prototype.stopLogStream = function () {
    clearInterval(this._logInterval);
    clearTimeout(this._logFinalizeTimer);
    this._logInterval = null;
    this._logFinalizeTimer = null;
  };

  SpeedTest.prototype.rotateFact = function () {
    var self = this;
    var idx = 0;
    var shuffled = LOADING_FACTS.slice().sort(function () { return Math.random() - 0.5; });
    if (this.factEl) this.factEl.textContent = shuffled[0];
    this._factInterval = setInterval(function () {
      idx = (idx + 1) % shuffled.length;
      if (self.factEl) {
        self.factEl.style.opacity = '0';
        setTimeout(function () {
          self.factEl.textContent = shuffled[idx];
          self.factEl.style.opacity = '1';
        }, 250);
      }
    }, 5500);
  };

  SpeedTest.prototype.startPatienceEscalation = function () {
    var self = this;
    if (!this.patienceEl || !this.patienceTextEl) return;
    // Reset auf default state (falls vorher in error/reset war)
    this.patienceEl.classList.remove('is-warning', 'is-final');
    this.patienceTextEl.innerHTML = 'Hinweis: Google rendert deinen Shop auf einem echten Mobile-Gerät. Bei vielen Apps oder schwerem Theme kann die Analyse <strong>bis zu 3 Minuten dauern</strong> — bitte nicht abbrechen.';
    clearTimeout(this._patienceWarnTimer);
    clearTimeout(this._patienceFinalTimer);
    // Nach 30s: "läuft noch, alles normal"
    this._patienceWarnTimer = setTimeout(function () {
      if (!self.patienceEl) return;
      self.patienceEl.classList.add('is-warning');
      self.patienceTextEl.innerHTML = 'Lighthouse misst gerade Mobile + Desktop <strong>parallel auf 3 separaten API-Keys</strong>. Bei vielen Apps + schwerem Theme dauert das jetzt einen Moment — alles läuft.';
    }, 30000);
    // Nach 90s: "fast da"
    this._patienceFinalTimer = setTimeout(function () {
      if (!self.patienceEl) return;
      self.patienceEl.classList.remove('is-warning');
      self.patienceEl.classList.add('is-final');
      self.patienceTextEl.innerHTML = 'Fast geschafft. Google sammelt die letzten Metriken — bei langsamen Shops kann das insgesamt <strong>bis zu 3 Minuten</strong> dauern. Bitte nicht schließen.';
    }, 90000);
  };

  SpeedTest.prototype.stopPatienceEscalation = function () {
    clearTimeout(this._patienceWarnTimer);
    clearTimeout(this._patienceFinalTimer);
  };

  SpeedTest.prototype.fetchPSI = function (url, strategy, attempt) {
    var self = this;
    attempt = attempt || 1;
    var params = new URLSearchParams();
    params.set('url', url);
    params.set('strategy', strategy);
    params.set('category', 'performance');
    var key = pickKey(strategy);
    if (key) params.set('key', key);
    var endpoint = 'https://www.googleapis.com/pagespeedonline/v5/runPagespeed?' + params.toString();
    // Timeout pro Call: 120s. PSI dauert real 30-60s, manchmal 90s — Timeout darf
    // nicht zu kurz sein, sonst killen wir gesunde Requests. Nur echte Hangs catchen.
    var controller = new AbortController();
    var timeoutMs = 120000;
    var timeoutId = setTimeout(function () { controller.abort(); }, timeoutMs);
    return fetch(endpoint, { signal: controller.signal }).then(function (res) {
      clearTimeout(timeoutId);
      if (res.ok) return res.json();
      if (res.status === 400) {
        throw new Error('Diese URL konnte nicht analysiert werden. Ist der Shop öffentlich erreichbar (nicht password-protected)?');
      }
      if (res.status === 404) {
        throw new Error('Die URL existiert nicht oder leitet nicht weiter. Bitte URL prüfen.');
      }
      if (res.status === 429) {
        // Rate-Limit (QPS oder daily) — retry mit Backoff
        if (attempt < 3) {
          var backoff = 3000 + attempt * 2000; // 5s, 7s
          return self.wait(backoff).then(function () { return self.fetchPSI(url, strategy, attempt + 1); });
        }
        throw new Error('Aktuell hohe Auslastung (mehrere Tests gleichzeitig). Bitte 1–2 Minuten warten und erneut versuchen.');
      }
      if (res.status >= 500 && attempt < 2) {
        return self.wait(2000).then(function () { return self.fetchPSI(url, strategy, attempt + 1); });
      }
      if (res.status >= 500) {
        throw new Error('Google konnte deinen Shop nicht analysieren (' + strategy + ', Status ' + res.status + '). Häufige Ursachen: Seite lädt länger als 30 s, Cloudflare/Bot-Protection blockt den Crawler oder Server-Timeout. Versuch es in 1–2 Minuten nochmal.');
      }
      throw new Error('Google PageSpeed API Error (Status ' + res.status + ')');
    }).catch(function (err) {
      clearTimeout(timeoutId);
      // Timeout via AbortController → 1× retry mit längerer Wartezeit
      if (err && err.name === 'AbortError') {
        if (attempt < 2) {
          return self.wait(3000).then(function () { return self.fetchPSI(url, strategy, attempt + 1); });
        }
        throw new Error('Google PageSpeed antwortet nicht (' + strategy + ', > 120 s pro Call). Aktuell hohe Auslastung — bitte in 1–2 Minuten erneut versuchen.');
      }
      // Network-level error (CORS, offline, DNS) — retry einmal
      if (err && err.name === 'TypeError' && attempt < 2) {
        return self.wait(1500).then(function () { return self.fetchPSI(url, strategy, attempt + 1); });
      }
      throw err;
    });
  };

  SpeedTest.prototype.setStep = function (step) {
    var steps = Array.prototype.slice.call(this.stepsEl.children);
    var order = ['connect', 'mobile', 'desktop', 'interpret', 'impact'];
    var currentIdx = order.indexOf(step);
    steps.forEach(function (li, i) {
      li.classList.toggle('is-active', i === currentIdx);
      li.classList.toggle('is-done', i < currentIdx);
    });
  };

  /* Zwei-Phasen-Kurve, monoton wachsend, läuft IMMER:
     Phase 1 (0-50s): asymptotisch gegen 82%, tau=20 — gut verteilt für typische 30-50s Runs
       → 5s≈21%, 10s≈37%, 20s≈59%, 30s≈73%, 45s≈84%
     Phase 2 (50s+): zusätzlicher slow-creep gegen 97%, tau=40 — verhindert Hängen bei langen Läufen
       → 60s≈85%, 90s≈90%, 120s≈93% */
  SpeedTest.prototype.startProgressAnimation = function () {
    var self = this;
    this._progress = 0;
    this._progressStart = Date.now();
    this._progressInterval = setInterval(function () {
      var elapsed = (Date.now() - self._progressStart) / 1000;
      var phase1 = 82 * (1 - Math.exp(-elapsed / 20));
      var phase2 = elapsed > 30 ? 15 * (1 - Math.exp(-(elapsed - 30) / 40)) : 0;
      var target = Math.min(97, phase1 + phase2);
      if (target > self._progress) {
        self._progress = target;
        self.setProgress(self._progress);
      }
    }, 100);
  };

  SpeedTest.prototype.stopProgressAnimation = function (finalValue) {
    clearInterval(this._progressInterval);
    clearInterval(this._factInterval);
    this.stopPatienceEscalation();
    this.setProgress(finalValue);
  };

  SpeedTest.prototype.setProgress = function (pct) {
    var clamped = Math.max(0, Math.min(100, pct));
    if (this.percentEl) this.percentEl.textContent = Math.round(clamped);
    var arcLength = 590.6; // 2 * PI * 94
    if (this.radarProgress) this.radarProgress.style.strokeDashoffset = arcLength - (arcLength * clamped / 100);
  };

  SpeedTest.prototype.showError = function (msg) {
    this.loading.hidden = true;
    this.results.hidden = true;
    this.hero.hidden = false;
    this.error.hidden = false;
    var msgEl = this.root.querySelector('[data-stf-error-msg]');
    if (msgEl) msgEl.textContent = msg;
    clearInterval(this._progressInterval);
    clearInterval(this._factInterval);
    clearInterval(this._logInterval);
    this.stopPatienceEscalation();
  };

  SpeedTest.prototype.extractScreenshots = function (lhr) {
    var finalShot = lhr.audits && lhr.audits['final-screenshot'] && lhr.audits['final-screenshot'].details;
    var thumbs = lhr.audits && lhr.audits['screenshot-thumbnails'] && lhr.audits['screenshot-thumbnails'].details;
    return {
      final: finalShot && finalShot.data ? finalShot.data : null,
      filmstrip: thumbs && thumbs.items ? thumbs.items : []
    };
  };

  SpeedTest.prototype.extractMetrics = function (lhr) {
    var a = lhr.audits;
    return {
      score: Math.round((lhr.categories.performance.score || 0) * 100),
      lcp: (a['largest-contentful-paint'] || {}).numericValue || 0,
      fcp: (a['first-contentful-paint'] || {}).numericValue || 0,
      cls: (a['cumulative-layout-shift'] || {}).numericValue || 0,
      tbt: (a['total-blocking-time'] || {}).numericValue || 0,
      si: (a['speed-index'] || {}).numericValue || 0,
      tti: (a['interactive'] || {}).numericValue || 0
    };
  };

  SpeedTest.prototype.extractOpportunities = function (lhr, metrics, maxCount) {
    var opps = [];
    var audits = lhr.audits;
    Object.keys(audits).forEach(function (id) {
      var audit = audits[id];
      if (audit.score === null || audit.score === 1) return;
      var savingsMs = (audit.details && audit.details.overallSavingsMs) || 0;
      var savingsBytes = (audit.details && audit.details.overallSavingsBytes) || 0;
      var interp = SHOPIFY_AUDITS[id];
      if (!interp && savingsMs < 150 && savingsBytes < 20000) return;
      var estimatedSavingsMs = 0;
      if (savingsMs === 0 && interp && metrics) {
        estimatedSavingsMs = Math.round(estimateAuditSavingsMs(id, metrics) / 10) * 10;
      }
      opps.push({
        id: id, score: audit.score, title: audit.title, description: audit.description,
        savingsMs: savingsMs, savingsBytes: savingsBytes,
        estimatedSavingsMs: estimatedSavingsMs,
        displayValue: audit.displayValue || '',
        interpretation: interp
      });
    });
    return opps
      .filter(function (o) { return o.interpretation || o.savingsMs > 500; })
      .sort(function (a, b) {
        var effA = a.savingsMs || a.estimatedSavingsMs;
        var effB = b.savingsMs || b.estimatedSavingsMs;
        var scoreA = effA + a.savingsBytes / 10 + (a.interpretation ? 500 : 0);
        var scoreB = effB + b.savingsBytes / 10 + (b.interpretation ? 500 : 0);
        return scoreB - scoreA;
      })
      .slice(0, maxCount || 8);
  };

  SpeedTest.prototype.scoreGrade = function (score) {
    if (score >= 90) return { label: 'Exzellent', color: '#2F7A3E' };
    if (score >= 75) return { label: 'Solide', color: '#6B9A2E' };
    if (score >= 50) return { label: 'Optimierbar', color: '#C8691F' };
    if (score >= 30) return { label: 'Schlecht', color: '#D14A24' };
    return { label: 'Kritisch', color: '#B82920' };
  };

  SpeedTest.prototype.metricGrade = function (key, value) {
    var t = {
      lcp: [2500, 4000], fcp: [1800, 3000], cls: [0.1, 0.25],
      tbt: [200, 600], si: [3400, 5800], tti: [3800, 7300]
    };
    var bounds = t[key];
    if (!bounds) return 'ni';
    if (value <= bounds[0]) return 'good';
    if (value <= bounds[1]) return 'ni';
    return 'poor';
  };

  SpeedTest.prototype.formatMs = function (ms) {
    if (ms >= 1000) return (ms / 1000).toFixed(1) + ' s';
    return Math.round(ms) + ' ms';
  };

  SpeedTest.prototype.formatSavings = function (ms) {
    if (ms <= 0) return '';
    if (ms < 100) return '<0,1 s';
    return (ms / 1000).toFixed(1).replace('.', ',') + ' s';
  };

  SpeedTest.prototype.formatBytes = function (bytes) {
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(1) + ' MB';
    if (bytes >= 1024) return (bytes / 1024).toFixed(0) + ' KB';
    return bytes + ' B';
  };

  SpeedTest.prototype.formatEuro = function (value) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value);
    } catch (e) {
      return '€ ' + Math.round(value).toLocaleString('de-DE');
    }
  };

  SpeedTest.prototype.calculateImpact = function (currentLcp, monthlyRevenue) {
    var targetLcp = 2000;
    var improvementMs = Math.max(0, currentLcp - targetLcp);
    var improvementSec = improvementMs / 1000;
    // Industry-Blend (Walmart +2%/s, Amazon +1%/100ms = 10%/s), konservativ:
    // ~2% Conversion-Lift pro 1s Ladezeit-Verbesserung, Cap bei 12%.
    // Diminishing returns: ab 3s Verbesserung flacht es ab (sqrt-ähnlich).
    var rawLift = improvementSec * 2;
    if (improvementSec > 3) {
      rawLift = 6 + Math.sqrt(improvementSec - 3) * 2.2;
    }
    var convLiftPct = Math.min(12, rawLift);
    var monthlyUplift = monthlyRevenue * (convLiftPct / 100);
    return {
      improvementMs: improvementMs, improvementSec: improvementSec,
      convLiftPct: convLiftPct, monthlyUplift: monthlyUplift,
      yearlyUplift: monthlyUplift * 12, currentLcp: currentLcp, targetLcp: targetLcp
    };
  };

  SpeedTest.prototype.escape = function (s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };

  SpeedTest.prototype.render = function (data) {
    this.loading.hidden = true;
    var m = this.extractMetrics(data.mobile.lighthouseResult);
    var d = this.extractMetrics(data.desktop.lighthouseResult);
    var opps = this.extractOpportunities(data.mobile.lighthouseResult, m);
    var shotsMobile = this.extractScreenshots(data.mobile.lighthouseResult);
    var shotsDesktop = this.extractScreenshots(data.desktop.lighthouseResult);
    this.results.innerHTML = this.buildResultsHTML({
      url: data.url, mobile: m, desktop: d, opportunities: opps,
      shotsMobile: shotsMobile, shotsDesktop: shotsDesktop
    });
    this.results.hidden = false;
    this.bindImpactCalc(m.lcp);
    this.bindTipToggles();
    this.bindCtaCalendly();
    this.lastUrl = data.url;
    // Scores für späteren Lead-Webhook merken — falls User durchs Email-Gate geht
    this.lastScores = { mobile: m, desktop: d, opportunities: opps };
    // Anonymes Test-Event feuern — egal ob User später Email gibt oder nicht.
    // So bekommen wir auch URLs von Non-Convertern für Cold-Outreach.
    this.firePublicTestEvent({ url: data.url, mobile: m, desktop: d, opportunities: opps });

    // Enrichment: falls User vorher schon Bait-Popup submittet hat (ohne Test-Daten),
    // jetzt die Bait-Row im Sheet mit den Test-Scores nachträglich enrichen.
    this.enrichBaitRowIfPending(m, d, opps, data.url);
    var self = this;
    requestAnimationFrame(function () {
      self.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      self.animateScoreCircles();
    });
    if (this.gateConfig.enabled && !this.gateAlreadyPassed()) {
      this.bindGateForm();
      this.armGateScrollTrigger();
    }
  };

  SpeedTest.prototype.animateScoreCircles = function () {
    var circles = this.results.querySelectorAll('.stf-score-fill[data-target-offset]');
    circles.forEach(function (c) {
      var target = c.getAttribute('data-target-offset');
      requestAnimationFrame(function () { c.style.strokeDashoffset = target; });
    });
  };

  SpeedTest.prototype.bindTipToggles = function () {
    var self = this;
    var tips = this.results.querySelectorAll('.stf-tip[data-tip]');
    if (!tips.length) return;

    // Singleton floating tooltip am Body — keine Parent-Overflow-Probleme
    var floater = document.querySelector('[data-stf-floating-tip]');
    if (!floater) {
      floater = document.createElement('div');
      floater.className = 'stf-floating-tip';
      floater.setAttribute('data-stf-floating-tip', '');
      document.body.appendChild(floater);
    }

    var activeTip = null;
    var hideTimer = null;

    var positionFloater = function (tipEl) {
      var rect = tipEl.getBoundingClientRect();
      // Erst sichtbar machen für korrekte Maße
      floater.style.left = '0px';
      floater.style.top = '0px';
      var fRect = floater.getBoundingClientRect();
      var margin = 12;
      var arrowOffset = 0;

      // Default: oberhalb des Tips, horizontal zentriert
      var left = rect.left + rect.width / 2 - fRect.width / 2;
      var top = rect.top - fRect.height - 10;
      var below = false;

      // Wenn oben kein Platz → unterhalb anzeigen
      if (top < margin) {
        top = rect.bottom + 10;
        below = true;
      }

      // Horizontale Begrenzung an Viewport
      var maxLeft = window.innerWidth - fRect.width - margin;
      if (left < margin) {
        arrowOffset = (rect.left + rect.width / 2) - margin;
        left = margin;
      } else if (left > maxLeft) {
        arrowOffset = (rect.left + rect.width / 2) - maxLeft;
        left = maxLeft;
      } else {
        arrowOffset = fRect.width / 2;
      }

      floater.style.left = Math.round(left) + 'px';
      floater.style.top = Math.round(top) + 'px';
      floater.style.setProperty('--tip-arrow-x', Math.round(arrowOffset) + 'px');
      floater.classList.toggle('is-below', below);
    };

    var showTip = function (tipEl) {
      clearTimeout(hideTimer);
      activeTip = tipEl;
      floater.textContent = tipEl.getAttribute('data-tip') || '';
      floater.classList.remove('is-visible');
      // Doppelt rAF damit Layout aktualisiert bevor positioniert
      requestAnimationFrame(function () {
        positionFloater(tipEl);
        requestAnimationFrame(function () { floater.classList.add('is-visible'); });
      });
      tipEl.classList.add('is-open');
    };

    var hideTip = function () {
      if (activeTip) activeTip.classList.remove('is-open');
      activeTip = null;
      floater.classList.remove('is-visible');
    };

    tips.forEach(function (tip) {
      tip.addEventListener('mouseenter', function () { showTip(tip); });
      tip.addEventListener('mouseleave', function () {
        hideTimer = setTimeout(hideTip, 100);
      });
      tip.addEventListener('focus', function () { showTip(tip); });
      tip.addEventListener('blur', function () { hideTip(); });
      tip.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (activeTip === tip) hideTip(); else showTip(tip);
      });
    });

    var outsideHandler = function (e) {
      if (activeTip && !e.target.closest('.stf-tip')) hideTip();
    };
    document.addEventListener('click', outsideHandler);
    var scrollHandler = function () {
      if (activeTip) positionFloater(activeTip);
    };
    window.addEventListener('scroll', scrollHandler, { passive: true });
    window.addEventListener('resize', scrollHandler, { passive: true });
  };

  /* ============ Calendly Popup-Widget ============ */

  SpeedTest.prototype.isCalendlyUrl = function (url) {
    return /^https?:\/\/(www\.)?calendly\.com\//i.test(url || '');
  };

  SpeedTest.prototype.loadCalendlyAssets = function () {
    if (this._calendlyPromise) return this._calendlyPromise;
    this._calendlyPromise = new Promise(function (resolve) {
      if (!document.querySelector('link[href*="calendly.com/assets/external/widget.css"]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://assets.calendly.com/assets/external/widget.css';
        document.head.appendChild(link);
      }
      if (window.Calendly && window.Calendly.initPopupWidget) { resolve(); return; }
      if (document.querySelector('script[src*="calendly.com/assets/external/widget.js"]')) {
        // Schon im Laden — pollen bis Calendly verfügbar
        var poll = setInterval(function () {
          if (window.Calendly && window.Calendly.initPopupWidget) {
            clearInterval(poll); resolve();
          }
        }, 100);
        setTimeout(function () { clearInterval(poll); resolve(); }, 8000);
        return;
      }
      var script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.onload = function () { resolve(); };
      script.onerror = function () { resolve(); };
      document.head.appendChild(script);
    });
    return this._calendlyPromise;
  };

  SpeedTest.prototype.openCalendly = function (url, prefill) {
    var self = this;
    this.loadCalendlyAssets().then(function () {
      if (!window.Calendly || !window.Calendly.initPopupWidget) {
        // Fallback: Tab öffnen, wenn Widget nicht lädt
        window.open(url, '_blank', 'noopener');
        return;
      }
      window.Calendly.initPopupWidget({ url: url, prefill: prefill || {} });
    });
  };

  SpeedTest.prototype.bindCtaCalendly = function () {
    var self = this;
    var btn = this.results.querySelector('[data-stf-calendly]');
    if (!btn) return;
    var url = btn.getAttribute('data-calendly-url');
    // Assets schon vor dem Klick laden → Popup öffnet ohne spürbare Latenz
    this.loadCalendlyAssets();
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var prefill = {};
      var lead = self.lastLeadData;
      if (lead) {
        if (lead.email) prefill.email = lead.email;
        // Calendly nutzt customAnswers für eigene Fragen (a1, a2, ...).
        // User muss in Calendly Event-Type "Phone" + "Shop-URL" als Custom-Questions anlegen.
        var ca = {};
        if (lead.phone) ca.a1 = lead.phone;
        if (lead.url) ca.a2 = lead.url;
        if (Object.keys(ca).length) prefill.customAnswers = ca;
      }
      // UTM-Tracking für Calendly-Analytics
      var utm = {
        utmSource: 'speed-test-funnel',
        utmMedium: 'organic',
        utmCampaign: 'page-speed-funnel'
      };
      self.openCalendly(url, prefill);
      // Meta-Event: Schedule (Lead → Booking-Intent)
      if (window.fbq) {
        window.fbq('track', 'Schedule', {
          content_name: 'Strategy Call Booked',
          source_url: self.lastUrl || ''
        }, { eventID: self.genEventId('schedule') });
      }
    });
  };

  SpeedTest.prototype.gateAlreadyPassed = function () {
    try { return localStorage.getItem('stf_gate_passed') === '1'; } catch (e) { return false; }
  };

  SpeedTest.prototype.armGateScrollTrigger = function () {
    var self = this;
    var gated = this.results.querySelector('[data-stf-gated]');
    if (!gated) return;
    if (this._gateObserver) { this._gateObserver.disconnect(); this._gateObserver = null; }
    clearTimeout(this._gateFallbackTimer);
    var fired = false;
    var trigger = function () {
      if (fired) return;
      fired = true;
      if (self._gateObserver) { self._gateObserver.disconnect(); self._gateObserver = null; }
      clearTimeout(self._gateFallbackTimer);
      self.showEmailGate();
    };
    if ('IntersectionObserver' in window) {
      this._gateObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > 0.05) trigger();
        });
      }, { threshold: [0, 0.05, 0.2], rootMargin: '0px 0px -10% 0px' });
      this._gateObserver.observe(gated);
    }
    this._gateFallbackTimer = setTimeout(trigger, 30000);
  };

  SpeedTest.prototype.showEmailGate = function () {
    var gated = this.results.querySelector('[data-stf-gated]');
    var overlay = this.results.querySelector('[data-stf-gate]');
    if (gated) gated.classList.add('is-gated');
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
      var input = overlay.querySelector('[data-stf-gate-input]');
      if (input) setTimeout(function () { input.focus(); }, 350);
    }
    document.body.style.overflow = 'hidden';
  };

  SpeedTest.prototype.unlockGate = function () {
    var gated = this.results.querySelector('[data-stf-gated]');
    var overlay = this.results.querySelector('[data-stf-gate]');
    if (gated) gated.classList.remove('is-gated');
    if (overlay) {
      overlay.classList.remove('is-visible');
      setTimeout(function () { overlay.hidden = true; }, 320);
    }
    document.body.style.overflow = '';
    try { localStorage.setItem('stf_gate_passed', '1'); } catch (e) {}
  };

  SpeedTest.prototype.normalizePhone = function (raw) {
    var d = String(raw || '').trim().replace(/[\s\-().\/]/g, '');
    if (!d) return { valid: false };
    // 0049 / 0043 → +49 / +43
    if (d.indexOf('0049') === 0) d = '+49' + d.substring(4);
    else if (d.indexOf('0043') === 0) d = '+43' + d.substring(4);
    // Leading 0 ohne Country-Code → smart-detect aus URL-TLD
    else if (d.charAt(0) === '0' && /^\d+$/.test(d.substring(1))) {
      var url = (this.lastUrl || '').toLowerCase();
      var isAt = /\.at(\/|$)/.test(url);
      d = (isAt ? '+43' : '+49') + d.substring(1);
    }
    if (d.charAt(0) !== '+') return { valid: false };
    var match;
    // DE Mobile: 015X (0,1,2,5,7,9) / 016X (0,2,3) / 017X (alle) — Vorwahl 3 + Subscriber 7-8 Ziffern
    if ((match = d.match(/^\+49(15[0125789]|16[023]|17[0-9])(\d{7,8})$/))) {
      var deDigits = match[1] + match[2];
      if (this.isJunkDigits(deDigits)) return { valid: false, reason: 'junk' };
      return { valid: true, e164: d, country: 'DE' };
    }
    // AT Mobile: 06XX wo zweite Ziffer 5-9 (650, 660, 664, 676, 680, 690, 699 etc.)
    if ((match = d.match(/^\+43(6[5-9]\d)(\d{6,8})$/))) {
      var atDigits = match[1] + match[2];
      if (this.isJunkDigits(atDigits)) return { valid: false, reason: 'junk' };
      return { valid: true, e164: d, country: 'AT' };
    }
    // Format-grundsätzlich-OK aber nicht Mobile (Festnetz, Sondernummer) → eigener Reason für klarere UX
    if (/^\+49\d{6,12}$/.test(d) || /^\+43\d{6,13}$/.test(d)) {
      return { valid: false, reason: 'notmobile' };
    }
    return { valid: false };
  };

  SpeedTest.prototype.isJunkDigits = function (digits) {
    if (!digits) return true;
    // alle gleich: 1111111111
    if (/^(\d)\1+$/.test(digits)) return true;
    // strikt aufsteigend (1234567890, 0123456789) oder absteigend (9876543210)
    var asc = true, desc = true;
    for (var i = 1; i < digits.length; i++) {
      var p = parseInt(digits.charAt(i - 1), 10);
      var c = parseInt(digits.charAt(i), 10);
      if (c !== (p + 1) % 10) asc = false;
      if (c !== (p - 1 + 10) % 10) desc = false;
    }
    if (asc || desc) return true;
    // weniger als 4 unique digits → wahrscheinlich Garbage
    var unique = {};
    for (var j = 0; j < digits.length; j++) unique[digits.charAt(j)] = 1;
    var keys = 0;
    for (var k in unique) { if (unique.hasOwnProperty(k)) keys++; }
    if (keys < 4) return true;
    return false;
  };

  SpeedTest.prototype.validateEmail = function (email) {
    var clean = String(email || '').trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(clean)) {
      return { valid: false, reason: 'format' };
    }
    var domain = clean.split('@')[1];
    if (DISPOSABLE_EMAIL_DOMAINS.hasOwnProperty(domain)) {
      return { valid: false, reason: 'disposable' };
    }
    return { valid: true, domain: domain };
  };

  // Backwards-compat shim — bestehende Aufrufer geben nur boolean zurück
  SpeedTest.prototype.isValidEmail = function (email) {
    return this.validateEmail(email).valid;
  };

  SpeedTest.prototype.parseUrlDomain = function (url) {
    if (!url) return '';
    return String(url).replace(/^https?:\/\//i, '').replace(/^www\./i, '').split(/[\/?#]/)[0].toLowerCase();
  };

  SpeedTest.prototype.isDomainMatching = function (emailDomain, urlDomain) {
    if (!emailDomain || !urlDomain) return false;
    if (emailDomain === urlDomain) return true;
    // shop.example.com URL + @example.com email
    if (urlDomain.indexOf('.') !== -1 && urlDomain.substring(urlDomain.indexOf('.') + 1) === emailDomain) return true;
    // @shop.example.com email + example.com URL
    if (emailDomain.indexOf('.') !== -1 && emailDomain.substring(emailDomain.indexOf('.') + 1) === urlDomain) return true;
    // Apex-Vergleich (letzte 2 Labels) — example.de matches shop.example.de
    var emailApex = emailDomain.split('.').slice(-2).join('.');
    var urlApex = urlDomain.split('.').slice(-2).join('.');
    return emailApex.length > 3 && emailApex === urlApex;
  };

  SpeedTest.prototype.firePublicTestEvent = function (payload) {
    var hook = this.gateConfig.publicTestWebhook;
    if (!hook) return;
    try {
      var domain = this.parseUrlDomain(payload.url);
      var tld = (domain.split('.').pop() || '').toLowerCase();
      var countryHint = tld === 'at' ? 'AT' : (tld === 'de' ? 'DE' : 'UNKNOWN');
      // UTM-Params von der aktuellen Page-URL ziehen (nicht von der getesteten URL)
      var utm = {};
      try {
        var qp = new URLSearchParams(window.location.search);
        ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'ex_s', 'ex_m'].forEach(function (k) {
          var v = qp.get(k);
          if (v) utm[k] = v;
        });
      } catch (e) { /* ignore */ }
      var topIssues = (payload.opportunities || []).slice(0, 5).map(function (o) {
        return { id: o.id || '', title: o.title || '', impact_ms: o.savingsMs || 0 };
      });
      var body = {
        event: 'speed_test_run',
        timestamp: new Date().toISOString(),
        url: payload.url,
        domain: domain,
        country_hint: countryHint,
        mobile_score: payload.mobile.score,
        desktop_score: payload.desktop.score,
        mobile_lcp_ms: Math.round(payload.mobile.lcp),
        mobile_cls: Math.round((payload.mobile.cls || 0) * 1000) / 1000,
        mobile_tbt_ms: Math.round(payload.mobile.tbt),
        mobile_fcp_ms: Math.round(payload.mobile.fcp),
        mobile_si_ms: Math.round(payload.mobile.si),
        desktop_lcp_ms: Math.round(payload.desktop.lcp),
        desktop_cls: Math.round((payload.desktop.cls || 0) * 1000) / 1000,
        top_issues: topIssues,
        referrer: document.referrer || '',
        page_url: window.location.href,
        user_agent: navigator.userAgent,
        utm: utm
      };
      // Fire-and-forget — keepalive damit's auch durchgeht falls User wegklickt.
      // text/plain statt application/json: CORS-safelisted → kein Preflight-OPTIONS,
      // funktioniert direkt mit Google Apps Script Web Apps (Make/n8n/Zapier auch).
      fetch(hook, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(body),
        keepalive: true,
        mode: 'cors'
      }).catch(function (e) { console.warn('[SpeedTest] public webhook failed', e); });
    } catch (e) {
      console.warn('[SpeedTest] firePublicTestEvent error', e);
    }
  };

  SpeedTest.prototype.bindGateForm = function () {
    var self = this;
    var form = this.results.querySelector('[data-stf-gate-form]');
    if (!form) return;
    var emailInput = form.querySelector('[data-stf-gate-email]');
    var phoneInput = form.querySelector('[data-stf-gate-phone]');
    var errorEl = form.querySelector('[data-stf-gate-error]');
    var hintEl = form.querySelector('[data-stf-gate-hint]');
    var btn = form.querySelector('button');

    var showError = function (msg, target) {
      if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
      if (target) { target.focus(); target.classList.add('has-error'); }
    };
    var clearError = function () {
      if (errorEl) { errorEl.textContent = ''; errorEl.hidden = true; }
      if (emailInput) emailInput.classList.remove('has-error');
      if (phoneInput) phoneInput.classList.remove('has-error');
    };
    var updateHint = function () {
      if (!hintEl) return;
      var raw = (emailInput && emailInput.value || '').trim();
      var check = self.validateEmail(raw);
      if (!check.valid) { hintEl.hidden = true; return; }
      var urlDomain = self.parseUrlDomain(self.lastUrl);
      if (!urlDomain || self.isDomainMatching(check.domain, urlDomain)) {
        hintEl.hidden = true;
        return;
      }
      hintEl.innerHTML = 'Tipp: Mit einer Email auf <strong>@' + self.escape(urlDomain) + '</strong> kommt die Analyse direkt beim Shop-Inhaber an.';
      hintEl.hidden = false;
    };
    var hintTimer;
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        clearError();
        clearTimeout(hintTimer);
        hintTimer = setTimeout(updateHint, 400);
      });
      emailInput.addEventListener('blur', updateHint);
    }
    if (phoneInput) phoneInput.addEventListener('input', clearError);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();
      var email = (emailInput && emailInput.value || '').trim();
      var phoneRaw = (phoneInput && phoneInput.value || '').trim();
      var emailCheck = self.validateEmail(email);
      if (!emailCheck.valid) {
        if (emailCheck.reason === 'disposable') {
          showError('Bitte eine echte Email-Adresse eintragen — Wegwerf-Adressen können wir nicht erreichen.', emailInput);
        } else {
          showError('Bitte eine gültige Email-Adresse eintragen.', emailInput);
        }
        return;
      }
      var phone = self.normalizePhone(phoneRaw);
      if (!phone.valid) {
        if (phone.reason === 'junk') {
          showError('Diese Nummer wirkt ungültig. Bitte deine echte Mobilnummer eintragen.', phoneInput);
        } else if (phone.reason === 'notmobile') {
          showError('Bitte eine Mobilnummer eintragen (DE: 015X/016X/017X, AT: 06XX). Festnetz können wir hier leider nicht annehmen.', phoneInput);
        } else {
          showError('Bitte eine gültige Mobilnummer aus DE oder AT eintragen (z.B. 0151 12345678 oder +43 664 1234567).', phoneInput);
        }
        return;
      }
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet...'; }
      self.submitLead(email, phone.e164, phone.country).then(function () {
        self.unlockGate();
      }).catch(function (err) {
        console.warn('[SpeedTest] lead submission failed', err);
        // User trotzdem durchlassen — Daten sind im Event/dataLayer für GTM-Recovery
        self.unlockGate();
      }).finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = origText; }
      });
    });
  };

  /* ============ Bait Popup (Lead-Catcher) ============
     Triggert 1× pro Session bei:
     A) 5s idle, URL-Input nie fokussiert
     B) URL-Input fokussiert + blur ohne Submit + 5s
     C) Email-Gate dismiss-attempt (X / Esc / Overlay-Click / Browser-Back) */

  SpeedTest.prototype.initBait = function () {
    if (this._baitInitialized) return;
    this._baitInitialized = true;
    this.baitBtn = document.querySelector('[data-stf-bait-btn]');
    this.baitPopup = document.querySelector('[data-stf-bait-popup]');
    if (!this.baitBtn || !this.baitPopup) return;

    this._baitShown = false;
    try { this._baitShown = !!sessionStorage.getItem('stf_bait_shown'); } catch (e) {}

    this.bindBaitElements();
    this.armBaitPreTestTriggers();
    this.armBaitGateExitTrigger();
    this.armBaitMobileChromeTrigger();
  };

  /* Trigger D — Mobile-Chrome-Expand (IG/Safari/FB in-app browsers).
     Wenn der User runterscrollt und dann wieder hochscrollt um zur Adress-Leiste
     zu kommen, expandiert der Browser-Chrome — visualViewport.height shrinkt.
     Das ist das verlässlichste Signal für "User will gleich raus" auf Mobile. */
  SpeedTest.prototype.armBaitMobileChromeTrigger = function () {
    var self = this;
    if (this._baitShown) return;
    if (!window.visualViewport) return; // Desktop / alte Browser → no-op

    var pageLoadedAt = Date.now();
    var minDwellMs = 8000; // erst nach 8s arm — sonst feuert es bei normalem Scroll-Verhalten gleich am Anfang
    var baselineHeight = window.visualViewport.height;
    var lastResizeAt = 0;

    var onResize = function () {
      if (self._baitShown) return;
      if (Date.now() - pageLoadedAt < minDwellMs) {
        // Update baseline während der Anfangsphase (Orientation-Change etc.)
        baselineHeight = Math.max(baselineHeight, window.visualViewport.height);
        return;
      }
      var now = Date.now();
      if (now - lastResizeAt < 400) return; // Debounce
      lastResizeAt = now;

      var current = window.visualViewport.height;
      var shrinkPx = baselineHeight - current;
      // Chrome-Expand: > 60px shrink in einem resize → User holt URL-Leiste hoch
      if (shrinkPx > 60) {
        self.showBaitPopup('mobile-chrome-expand');
      } else if (current > baselineHeight) {
        // Falls visualViewport gewachsen ist (z.B. Keyboard ging zu) — baseline anpassen
        baselineHeight = current;
      }
    };
    window.visualViewport.addEventListener('resize', onResize);
  };

  SpeedTest.prototype.armBaitPreTestTriggers = function () {
    var self = this;
    if (this._baitShown) return;

    var inputFocused = false;
    this._submitFired = false;

    // Track submit so we don't trigger after user actually started a test
    this.form.addEventListener('submit', function () { self._submitFired = true; });

    // Trigger A — 5s idle, input never focused
    this._baitIdleTimer = setTimeout(function () {
      if (!inputFocused && !self._baitShown && !self._submitFired) self.showBaitButton();
    }, 5000);

    // Trigger B — input focused + blur without submit, 5s timer
    this.urlInput.addEventListener('focus', function () {
      inputFocused = true;
      clearTimeout(self._baitIdleTimer);
      clearTimeout(self._baitBlurTimer);
    });
    this.urlInput.addEventListener('blur', function () {
      if (self._baitShown || self._submitFired) return;
      clearTimeout(self._baitBlurTimer);
      self._baitBlurTimer = setTimeout(function () {
        if (!self._baitShown && !self._submitFired) self.showBaitButton();
      }, 5000);
    });
  };

  SpeedTest.prototype.armBaitGateExitTrigger = function () {
    // Patch showEmailGate / unlockGate to wire up exit-detection.
    // Done via wrapping so original behavior stays intact.
    var self = this;
    var origShowGate = this.showEmailGate;
    this.showEmailGate = function () {
      origShowGate.apply(self, arguments);
      self._installGateExitHandlers();
    };
    var origUnlockGate = this.unlockGate;
    this.unlockGate = function () {
      origUnlockGate.apply(self, arguments);
      self._removeGateExitHandlers();
    };
  };

  SpeedTest.prototype._installGateExitHandlers = function () {
    var self = this;
    var overlay = this.results && this.results.querySelector('[data-stf-gate]');
    if (!overlay) return;

    // Document/Window-Listener vorab cleanen (überleben sonst Page-Renders → double-fire)
    if (this._gateExit_keyHandler) document.removeEventListener('keydown', this._gateExit_keyHandler);
    if (this._gateExit_popHandler) window.removeEventListener('popstate', this._gateExit_popHandler);

    // X-Button injektieren — IMMER neu, auch wenn schon einer da war (kann von altem Render stammen)
    var existing = overlay.querySelector('[data-stf-gate-x]');
    if (existing) existing.parentNode.removeChild(existing);
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'stf-gate-x';
    x.setAttribute('data-stf-gate-x', '');
    x.setAttribute('aria-label', 'Schließen');
    x.textContent = '×';
    overlay.appendChild(x);
    x.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      self._triggerBaitFromGate();
    });

    // Backdrop-click (overlay selbst, nicht die Card) — onclick statt addEventListener verhindert
    // double-bind über mehrere Render-Zyklen
    overlay.onclick = function (e) {
      if (e.target === overlay) self._triggerBaitFromGate();
    };

    // Escape
    this._gateExit_keyHandler = function (e) {
      var liveOverlay = self.results && self.results.querySelector('[data-stf-gate]');
      if (e.key === 'Escape' && liveOverlay && !liveOverlay.hidden) self._triggerBaitFromGate();
    };
    document.addEventListener('keydown', this._gateExit_keyHandler);

    // Browser-Back hijack
    try {
      history.pushState({ stfGate: true }, '', location.href);
      this._gateExit_popHandler = function () { self._triggerBaitFromGate(); };
      window.addEventListener('popstate', this._gateExit_popHandler);
    } catch (e) {}
  };

  SpeedTest.prototype._removeGateExitHandlers = function () {
    if (this._gateExit_keyHandler) {
      document.removeEventListener('keydown', this._gateExit_keyHandler);
      this._gateExit_keyHandler = null;
    }
    if (this._gateExit_popHandler) {
      window.removeEventListener('popstate', this._gateExit_popHandler);
      this._gateExit_popHandler = null;
    }
  };

  SpeedTest.prototype._triggerBaitFromGate = function () {
    // Gate ausblenden + Bait IMMER zeigen (force=true bypassed Session-Dedupe).
    // User kann das Gate nicht einfach wegklicken — entweder Gate ausfüllen,
    // Bait ausfüllen oder Tab schließen.
    var overlay = this.results && this.results.querySelector('[data-stf-gate]');
    if (overlay) {
      overlay.classList.remove('is-visible');
      var self = this;
      setTimeout(function () { overlay.hidden = true; }, 280);
    }
    document.body.style.overflow = '';
    this.showBaitPopup('gate-exit', true);
  };

  SpeedTest.prototype.showBaitButton = function () {
    if (this._baitShown || !this.baitBtn) return;
    this.baitBtn.hidden = false;
    var btn = this.baitBtn;
    requestAnimationFrame(function () { btn.classList.add('is-visible'); });
  };

  SpeedTest.prototype.hideBaitButton = function () {
    if (!this.baitBtn) return;
    this.baitBtn.classList.remove('is-visible');
    var btn = this.baitBtn;
    setTimeout(function () { btn.hidden = true; }, 500);
  };

  SpeedTest.prototype.showBaitPopup = function (triggerSource, force) {
    if (!this.baitPopup) return;
    // Session-Dedupe: hero-button / mobile-chrome / abandon-Trigger zeigen Bait
    // nur 1× pro Session. Aber gate-exit (force=true) IGNORIERT das Dedupe —
    // dort soll der User entweder konvertieren oder Tab schließen, kein Escape.
    if (!force && this._baitShown) return;
    this._baitShown = true;
    this._baitTriggerSource = triggerSource || 'unknown';
    try { sessionStorage.setItem('stf_bait_shown', '1'); } catch (e) {}
    this.hideBaitButton();
    this._customizeChoiceCopy(triggerSource);
    this.setBaitStep('choice');
    this.baitPopup.hidden = false;
    var pop = this.baitPopup;
    requestAnimationFrame(function () { pop.classList.add('is-visible'); });
    document.body.style.overflow = 'hidden';
  };

  SpeedTest.prototype._customizeChoiceCopy = function (triggerSource) {
    if (!this.baitPopup) return;
    var step = this.baitPopup.querySelector('[data-stf-bait-step="choice"]');
    if (!step) return;
    var hd = step.querySelector('.stf-bait-headline');
    var sub = step.querySelector('.stf-bait-subtext');
    var eb = step.querySelector('.stf-bait-eyebrow');
    var ebDot = eb && eb.querySelector('.stf-bait-eyebrow-mark');

    var copy;
    if (triggerSource === 'mobile-chrome-expand') {
      copy = {
        eyebrow: 'Ups',
        headline: 'Falscher Button — sorry.',
        subtext: 'Wenn du schon weg willst, schenken wir dir wenigstens was. Aussuchen:'
      };
    } else if (triggerSource === 'gate-exit') {
      copy = {
        eyebrow: 'Eine Sekunde noch',
        headline: 'Ok, wenn du keine Email gibst.',
        subtext: 'Lass uns dir was schenken — kostet dich gar nichts. Aussuchen:'
      };
    } else {
      // Default: hero-button / idle / abandon — keep original (already in HTML)
      return;
    }

    if (hd) hd.innerHTML = '';
    if (hd) hd.textContent = copy.headline;
    if (sub) sub.textContent = copy.subtext;
    if (eb && ebDot) {
      eb.innerHTML = '';
      eb.appendChild(ebDot);
      eb.appendChild(document.createTextNode(copy.eyebrow));
    }
  };

  SpeedTest.prototype.closeBaitPopup = function () {
    if (!this.baitPopup) return;
    var wasFromGate = this._baitTriggerSource === 'gate-exit';
    this.baitPopup.classList.remove('is-visible');
    var pop = this.baitPopup;
    var self = this;
    setTimeout(function () {
      pop.hidden = true;
      // Wenn Bait via Gate-X aufgemacht wurde und User NICHT konvertiert hat
      // (gate noch nicht passed), zeig das Gate wieder — zweite Chance.
      if (wasFromGate && !self.gateAlreadyPassed()) {
        var overlay = self.results && self.results.querySelector('[data-stf-gate]');
        if (overlay) {
          overlay.hidden = false;
          requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
          document.body.style.overflow = 'hidden';
          return;
        }
      }
      document.body.style.overflow = '';
    }, 320);
  };

  SpeedTest.prototype.setBaitStep = function (step) {
    if (!this.baitPopup) return;
    var steps = this.baitPopup.querySelectorAll('[data-stf-bait-step]');
    steps.forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-stf-bait-step') === step);
    });
    this._baitCurrentStep = step;
  };

  SpeedTest.prototype.configureBaitForm = function (variant) {
    this._baitVariant = variant;
    var copy = {
      'lp-qualified': {
        eyebrow: 'Premium-Slot',
        headline: 'Stark — los gehts.',
        subtext: 'Hans meldet sich heute noch persönlich für ein 15-Min-Briefing. Trag dich ein:'
      },
      'lp-pivot': {
        eyebrow: 'Bonus-Track',
        headline: 'Kein Stress.',
        subtext: 'Du kriegst stattdessen das Native Creative — damit kommst du auf 30K Adspend, dann bauen wir die LP. Trag dich ein, wir liefern in 24h:'
      },
      'creative-direct': {
        eyebrow: 'Native Creative',
        headline: 'Native Creative incoming.',
        subtext: 'Wir liefern in 24h ein ready-to-use Ad-Creative für Meta + TikTok. Trag dich ein:'
      }
    }[variant] || {};
    var hd = this.baitPopup.querySelector('[data-stf-bait-form-headline]');
    var sub = this.baitPopup.querySelector('[data-stf-bait-form-subtext]');
    var eb = this.baitPopup.querySelector('[data-stf-bait-form-eyebrow]');
    if (hd) hd.textContent = copy.headline || '';
    if (sub) sub.textContent = copy.subtext || '';
    if (eb) eb.textContent = copy.eyebrow || 'Fast geschafft';
    this.setBaitStep('form');
  };

  SpeedTest.prototype.bindBaitElements = function () {
    var self = this;

    // Bait button → popup
    this.baitBtn.addEventListener('click', function () { self.showBaitPopup('hero-button'); });

    // Close handlers
    this.baitPopup.querySelectorAll('[data-stf-bait-close]').forEach(function (el) {
      el.addEventListener('click', function () { self.closeBaitPopup(); });
    });

    // Choice → next step
    this.baitPopup.querySelectorAll('[data-stf-bait-pick]').forEach(function (el) {
      el.addEventListener('click', function () {
        self._baitOffer = el.getAttribute('data-stf-bait-pick');
        if (self._baitOffer === 'lp') self.setBaitStep('qualifier');
        else self.configureBaitForm('creative-direct');
      });
    });

    // Qualifier → form variant
    this.baitPopup.querySelectorAll('[data-stf-bait-qualified]').forEach(function (el) {
      el.addEventListener('click', function () {
        self._baitQualified = el.getAttribute('data-stf-bait-qualified');
        self.configureBaitForm(self._baitQualified === 'yes' ? 'lp-qualified' : 'lp-pivot');
      });
    });

    // Form submit
    var form = this.baitPopup.querySelector('[data-stf-bait-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.submitBaitForm(); });

    // Escape key — global
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.baitPopup && !self.baitPopup.hidden) self.closeBaitPopup();
    });
  };

  SpeedTest.prototype.submitBaitForm = function () {
    var self = this;
    var emailEl = this.baitPopup.querySelector('[data-stf-bait-email]');
    var phoneEl = this.baitPopup.querySelector('[data-stf-bait-phone]');
    var shopEl = this.baitPopup.querySelector('[data-stf-bait-shop]');
    var errEl = this.baitPopup.querySelector('[data-stf-bait-error]');
    var btn = this.baitPopup.querySelector('[data-stf-bait-submit]');

    var setError = function (msg, target) {
      if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
      if (target) { target.classList.add('has-error'); target.focus(); }
    };
    var clearError = function () {
      if (errEl) errEl.hidden = true;
      [emailEl, phoneEl, shopEl].forEach(function (el) { if (el) el.classList.remove('has-error'); });
    };
    clearError();

    var email = (emailEl && emailEl.value || '').trim();
    var phoneRaw = (phoneEl && phoneEl.value || '').trim();
    var shop = (shopEl && shopEl.value || '').trim();

    var emailCheck = this.validateEmail(email);
    if (!emailCheck.valid) {
      setError(emailCheck.reason === 'disposable'
        ? 'Bitte eine echte Email — Wegwerf-Adressen können wir nicht erreichen.'
        : 'Bitte eine gültige Email eintragen.', emailEl);
      return;
    }
    var phone = this.normalizePhone(phoneRaw);
    if (!phone.valid) {
      setError(phone.reason === 'notmobile'
        ? 'Bitte eine Mobilnummer (DE 015X/016X/017X, AT 06XX). Festnetz geht hier nicht.'
        : 'Bitte eine echte Mobilnummer aus DE oder AT.', phoneEl);
      return;
    }

    var origText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet...'; }

    var shopUrl = shop ? this.normalizeUrl(shop) || shop : (this.lastUrl || '');
    var shopDomain = this.parseUrlDomain(shopUrl);
    var source = 'speed-test-bait-' + (this._baitVariant || 'unknown');

    // Meta Lead ZUERST (sync) — gibt event_id zurück für Pixel↔CAPI-Dedup
    var leadEventId = '';
    try {
      leadEventId = this.fireMetaLead({ email: email, phone: phone.e164, country: phone.country, url: shopUrl }) || '';
    } catch (e) { console.warn('[Bait] Meta Lead failed', e); }

    var payload = {
      payload_type: 'popup_capture',
      timestamp: new Date().toISOString(),
      trigger_source: this._baitTriggerSource || 'unknown',
      offer_chosen: this._baitOffer || '',
      qualified: this._baitQualified || '',
      variant: this._baitVariant || '',
      email: email,
      phone: phone.e164,
      country: phone.country,
      // Beide Field-Sets damit's mit Apps Script v2 (Leads-Fallback) UND v3/v4 (Popup Captures Tab) funktioniert
      url: shopUrl,
      domain: shopDomain,
      shop_url: shopUrl,
      shop_domain: shopDomain,
      // source-Field für v2 Leads-Branch (sonst leer)
      source: 'speed-test-bait-' + (this._baitVariant || 'unknown'),
      page_url: location.href,
      referrer: document.referrer || '',
      lead_event_id: leadEventId
    };

    // Wenn Test schon gelaufen ist (Gate-Exit-Trigger): Scores direkt mitsenden — keine Enrichment nötig.
    // Sonst: Enrichment-Flag setzen, damit nach dem Test-Run die Row nachträglich enricht wird.
    var hasScores = !!this.lastScores;
    if (hasScores) {
      var m = this.lastScores.mobile, d = this.lastScores.desktop;
      payload.tested_url = this.lastUrl || '';
      payload.mobile_score = m.score;
      payload.desktop_score = d.score;
      payload.mobile_lcp_ms = Math.round(m.lcp);
      payload.mobile_cls = Math.round((m.cls || 0) * 1000) / 1000;
      payload.mobile_tbt_ms = Math.round(m.tbt);
      payload.mobile_fcp_ms = Math.round(m.fcp);
      payload.desktop_lcp_ms = Math.round(d.lcp);
      payload.desktop_cls = Math.round((d.cls || 0) * 1000) / 1000;
      payload.top_issues = (this.lastScores.opportunities || []).slice(0, 5)
        .map(function (o) { return (o.title || '') + ' (' + Math.round(o.savings_ms || 0) + 'ms)'; })
        .join(' · ');
    } else {
      // Bait kam pre-test → Enrichment-Marker setzen, damit nach Test-Run nachgeladen wird
      try {
        sessionStorage.setItem('stf_bait_enrich_pending', '1');
        sessionStorage.setItem('stf_bait_enrich_email', email);
      } catch (e) {}
    }

    // dataLayer + Custom DOM-Event für GTM / server-side CAPI
    try {
      this.root.dispatchEvent(new CustomEvent('stf:bait-captured', { detail: payload, bubbles: true }));
    } catch (e) {}
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: 'stf_bait_captured',
        event_id: leadEventId,
        stf_email: email,
        stf_phone: phone.e164,
        stf_country: phone.country,
        stf_url: shopUrl,
        stf_bait_variant: this._baitVariant || '',
        stf_bait_trigger: this._baitTriggerSource || ''
      });
    }

    var promises = [];
    if (this.gateConfig.webhook) {
      promises.push(fetch(this.gateConfig.webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        mode: 'cors',
        credentials: 'omit',
        keepalive: true
      }));
    }
    if (this.gateConfig.klaviyoKey) {
      // 1) Profile-Upsert + List-Subscribe
      promises.push(this.submitToKlaviyo({
        email: email,
        phone: phone.e164,
        country: phone.country,
        url: shopUrl,
        source: source
      }));
      // 2) Custom Event — triggert Klaviyo-Flows. Source-Property unterscheidet
      //    Bait- vs reguläre Gate-Submits in deinen Segmenten/Flows.
      promises.push(this.sendKlaviyoEvent({
        email: email,
        phone: phone.e164,
        country: phone.country,
        url: shopUrl,
        source: source,
        leadEventId: leadEventId
      }));
    }

    Promise.all(promises.map(function (p) {
      return p.then(function () { return true; }, function () { return false; });
    })).then(function () {
      self.setBaitStep('thanks');
      // Bonus: Wenn Gate noch nicht durch ist, unlock — Reward für Lead-Abgabe
      try { self.unlockGate(); } catch (e) {}
      if (btn) { btn.disabled = false; btn.textContent = origText; }
    });
  };

  SpeedTest.prototype.enrichBaitRowIfPending = function (mobile, desktop, opportunities, testedUrl) {
    var pending, email;
    try {
      pending = sessionStorage.getItem('stf_bait_enrich_pending') === '1';
      email = sessionStorage.getItem('stf_bait_enrich_email') || '';
    } catch (e) { return; }
    if (!pending || !email) return;
    if (!this.gateConfig.webhook) return;

    var payload = {
      action: 'enrich-bait-row',
      email: email,
      tested_url: testedUrl || '',
      mobile_score: mobile.score,
      desktop_score: desktop.score,
      mobile_lcp_ms: Math.round(mobile.lcp),
      mobile_cls: Math.round((mobile.cls || 0) * 1000) / 1000,
      mobile_tbt_ms: Math.round(mobile.tbt),
      mobile_fcp_ms: Math.round(mobile.fcp),
      desktop_lcp_ms: Math.round(desktop.lcp),
      desktop_cls: Math.round((desktop.cls || 0) * 1000) / 1000,
      top_issues: (opportunities || []).slice(0, 5)
        .map(function (o) { return (o.title || '') + ' (' + Math.round(o.savings_ms || 0) + 'ms)'; })
        .join(' · ')
    };

    fetch(this.gateConfig.webhook, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      mode: 'cors',
      credentials: 'omit',
      keepalive: true
    }).then(function () {
      try {
        sessionStorage.removeItem('stf_bait_enrich_pending');
        sessionStorage.removeItem('stf_bait_enrich_email');
      } catch (e) {}
    }).catch(function (e) {
      console.warn('[Bait] enrichment failed', e);
    });
  };

  /* ============ /Bait Popup ============ */

  SpeedTest.prototype.submitLead = function (email, phoneE164, country) {
    // Lead-Daten für Calendly-Prefill speichern
    this.lastLeadData = { email: email, phone: phoneE164, country: country, url: this.lastUrl || '' };
    // Meta Lead-Event ZUERST (sync) → event_id für CAPI-Dedup verfügbar
    var leadEventId = this.fireMetaLead({ email: email, phone: phoneE164, country: country, url: this.lastUrl || '' });
    var payload = {
      email: email,
      phone: phoneE164,
      country: country,
      url: this.lastUrl || '',
      source: 'speed-test-funnel',
      timestamp: new Date().toISOString(),
      view_content_event_id: this.lastViewContentEventId || '',
      lead_event_id: leadEventId
    };
    // PSI-Scores enrichen damit der Lead-Webhook direkt sieht was der User getestet hat
    if (this.lastScores) {
      payload.mobile_score = this.lastScores.mobile.score;
      payload.desktop_score = this.lastScores.desktop.score;
      payload.mobile_lcp_ms = Math.round(this.lastScores.mobile.lcp);
      payload.mobile_cls = Math.round((this.lastScores.mobile.cls || 0) * 1000) / 1000;
      payload.mobile_tbt_ms = Math.round(this.lastScores.mobile.tbt);
      payload.mobile_fcp_ms = Math.round(this.lastScores.mobile.fcp);
      payload.desktop_lcp_ms = Math.round(this.lastScores.desktop.lcp);
      payload.desktop_cls = Math.round((this.lastScores.desktop.cls || 0) * 1000) / 1000;
    }
    // dataLayer + Custom-Event (für GTM / server-side CAPI)
    try {
      this.root.dispatchEvent(new CustomEvent('stf:lead-captured', { detail: payload, bubbles: true }));
    } catch (e) {}
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: 'stf_lead_captured',
        event_id: leadEventId,
        stf_email: email,
        stf_phone: phoneE164,
        stf_country: country,
        stf_url: this.lastUrl || ''
      });
    }
    var promises = [];
    if (this.gateConfig.klaviyoKey) {
      // Erst Profil/Subscription, dann Custom-Event mit Properties (parallel)
      promises.push(this.submitToKlaviyo(payload));
      promises.push(this.sendKlaviyoEvent({
        email: email, phone: phoneE164, country: country,
        url: this.lastUrl || '', source: 'speed-test-funnel',
        leadEventId: leadEventId
      }));
    }
    if (this.gateConfig.webhook) {
      // text/plain → CORS-safelisted, kompatibel mit Google Apps Script Web Apps
      promises.push(fetch(this.gateConfig.webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        mode: 'cors',
        credentials: 'omit',
        keepalive: true
      }));
    }
    if (!promises.length) return Promise.resolve();
    return Promise.all(promises.map(function (p) {
      return p.then(function (r) { return { ok: true, r: r }; }, function (e) { return { ok: false, e: e }; });
    }));
  };

  /* ============ Meta Pixel Events ============
     Shopify's Meta-Integration lädt das Pixel + handled CAPI für Standard-Events.
     Wir feuern hier Custom-Events via window.fbq → Shopify's CAPI fängt sie auch ab.
     event_id wird mitgegeben für Pixel↔CAPI-Deduplication (Phase 2). */

  SpeedTest.prototype.initMetaPixel = function () {
    // No-op wenn Shopify's Meta-Integration das Pixel schon geladen hat
    if (window.fbq) return;
    // Fallback-Loader nur wenn ein Pixel-ID gesetzt ist UND fbq fehlt
    var pixelId = this.gateConfig.metaPixelId;
    if (!pixelId || window._stfPixelLoaded) return;
    window._stfPixelLoaded = true;
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  };

  SpeedTest.prototype.genEventId = function (prefix) {
    return (prefix || 'stf') + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 11);
  };

  SpeedTest.prototype.fireViewContent = function (url) {
    var eventId = this.genEventId('vc');
    this.lastViewContentEventId = eventId;
    var props = {
      content_name: 'Speed Test Started',
      content_category: 'speed_test_funnel',
      content_ids: [url],
      source_url: url
    };
    if (window.fbq) {
      window.fbq('track', 'ViewContent', props, { eventID: eventId });
    }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: 'stf_view_content', event_id: eventId, stf_url: url });
    }
    // DOM-Event für Custom Web Pixels / Theme-Code, die mitlauschen möchten
    try {
      this.root.dispatchEvent(new CustomEvent('stf:view-content', {
        detail: { event_id: eventId, url: url, timestamp: new Date().toISOString() },
        bubbles: true
      }));
    } catch (e) {}
  };

  SpeedTest.prototype.fireMetaLead = function (data) {
    var eventId = this.genEventId('lead');
    this.lastLeadEventId = eventId;
    if (!window.fbq) return eventId;
    var props = {
      content_name: 'Speed Test Lead',
      content_category: 'speed_test_funnel',
      source_url: data.url,
      value: 1,
      currency: 'EUR'
    };
    // Standard track + Advanced Matching via user_data im 3. Argument
    // Pixel hasht em/ph automatisch SHA-256 vor dem Versand
    window.fbq('track', 'Lead', props, {
      eventID: eventId,
      user_data: {
        em: data.email,
        ph: data.phone.replace(/^\+/, ''),
        country: data.country.toLowerCase()
      }
    });
    return eventId;
  };

  /* ============ Klaviyo ============ */

  SpeedTest.prototype.sendKlaviyoEvent = function (data) {
    var key = this.gateConfig.klaviyoKey;
    var eventName = this.gateConfig.klaviyoEvent;
    if (!key || !eventName) return Promise.resolve();
    var body = {
      data: {
        type: 'event',
        attributes: {
          properties: {
            store_url: data.url,
            country: data.country,
            source: data.source,
            phone: data.phone,
            meta_event_id: data.leadEventId || ''
          },
          metric: { data: { type: 'metric', attributes: { name: eventName } } },
          profile: {
            data: {
              type: 'profile',
              attributes: { email: data.email, phone_number: data.phone }
            }
          }
        }
      }
    };
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(body),
      mode: 'cors'
    });
  };

  SpeedTest.prototype.submitToKlaviyo = function (data) {
    var key = this.gateConfig.klaviyoKey;
    var listId = this.gateConfig.klaviyoList;
    var headers = { 'Content-Type': 'application/json', 'revision': '2024-10-15' };

    // 1) Profile-Upsert IMMER → setzt Custom Properties auf das Profil.
    //    (Subscription-Endpoint überträgt properties nicht zuverlässig auf bestehende Profile)
    var profileBody = {
      data: {
        type: 'profile',
        attributes: {
          email: data.email,
          phone_number: data.phone,
          properties: {
            store_url: data.url,
            country: data.country,
            source: data.source,
            submitted_at: data.timestamp,
            last_speed_test_url: data.url,
            last_speed_test_at: data.timestamp
          }
        }
      }
    };
    var profilePromise = fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(key), {
      method: 'POST', headers: headers, body: JSON.stringify(profileBody), mode: 'cors'
    });

    if (!listId) return profilePromise;

    // 2) Subscription-Endpoint → Email + SMS Consent + Listen-Add (triggert Welcome-Flow)
    var subBody = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Speed Test Funnel',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: data.email,
                phone_number: data.phone,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } },
                  sms:   { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };
    var subPromise = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
      method: 'POST', headers: headers, body: JSON.stringify(subBody), mode: 'cors'
    });

    return Promise.all([profilePromise, subPromise]);
  };

  SpeedTest.prototype.chapterRow = function (num, title, meta) {
    return '' +
      '<div class="stf-chapter-row">' +
        '<span class="stf-chapter-num">' + num + '</span>' +
        '<span class="stf-chapter-line"></span>' +
        '<span class="stf-chapter-meta">' + this.escape(meta) + '</span>' +
      '</div>';
  };

  SpeedTest.prototype.scoreCircleHTML = function (label, score, grade) {
    var r = 76;
    var circumference = 2 * Math.PI * r;
    var offset = circumference * (1 - score / 100);
    var isMobile = label.toLowerCase() === 'mobile';
    var icon = isMobile
      ? '<svg class="stf-score-platform-icon" viewBox="0 0 11 14" width="10" height="13" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<rect x="0.6" y="0.6" width="9.8" height="12.8" rx="1.6"/>' +
          '<line x1="4" y1="11.4" x2="7" y2="11.4"/>' +
        '</svg>'
      : '<svg class="stf-score-platform-icon" viewBox="0 0 14 14" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<rect x="0.6" y="1" width="12.8" height="9" rx="1"/>' +
          '<line x1="4.2" y1="13.4" x2="9.8" y2="13.4"/>' +
          '<line x1="7" y1="10" x2="7" y2="13.4"/>' +
        '</svg>';
    return '' +
      '<div class="stf-score-circle-wrap">' +
        '<div class="stf-score-circle" style="--score-color: ' + grade.color + '">' +
          '<svg viewBox="0 0 180 180" class="stf-score-svg">' +
            '<circle class="stf-score-track" cx="90" cy="90" r="' + r + '" fill="none" stroke-width="6"/>' +
            '<circle class="stf-score-fill" cx="90" cy="90" r="' + r + '" fill="none" stroke="' + grade.color + '" stroke-width="6" stroke-linecap="round" ' +
            'stroke-dasharray="' + circumference + '" stroke-dashoffset="' + circumference + '" data-target-offset="' + offset + '" transform="rotate(-90 90 90)"/>' +
          '</svg>' +
          '<div class="stf-score-number">' + score + '<span class="stf-score-outof">/100</span></div>' +
        '</div>' +
        '<div class="stf-score-platform">' + icon + '<span>' + label + '</span></div>' +
        '<div class="stf-score-grade">' + grade.label + '</div>' +
      '</div>';
  };

  SpeedTest.prototype.cwvBarSegs = function (grade) {
    var segs = ['', '', ''];
    if (grade === 'good') segs[0] = 'is-hit';
    else if (grade === 'ni') { segs[0] = 'is-hit'; segs[1] = 'is-hit'; }
    else { segs[0] = 'is-hit'; segs[1] = 'is-hit'; segs[2] = 'is-hit'; }
    return segs.map(function (s) { return '<span class="stf-cwv-bar-seg ' + s + '"></span>'; }).join('');
  };

  SpeedTest.prototype.cwvContext = function (key) {
    var map = {
      LCP: {
        deepTip: 'LCP (Largest Contentful Paint) misst, wann dein größtes sichtbares Element gerendert ist — meistens das Hero-Bild. Google-Schwellen: Gut < 2,5 s · Verbesserungswürdig 2,5–4 s · Schlecht > 4 s.',
        quickWin: 'Hero-Bild via `<link rel="preload" as="image" fetchpriority="high">` vorladen. Nicht-kritische Scripts auf `defer` umstellen. Kein `loading="lazy"` aufs LCP-Element.'
      },
      CLS: {
        deepTip: 'CLS (Cumulative Layout Shift) misst, wie stark sich das Layout beim Laden verschiebt. Jedes springende Element verwirrt den User. Google-Schwellen: Gut < 0,1 · Verbesserungswürdig 0,1–0,25 · Schlecht > 0,25.',
        quickWin: 'Allen Bildern und Videos `width` und `height` setzen. Cookie-Banner als Overlay (`position: fixed`), nicht als Push-Down.'
      },
      TBT: {
        deepTip: 'TBT (Total Blocking Time) misst, wie lange der Browser nicht auf User-Input reagiert, weil JavaScript den Main Thread blockiert. Google-Schwellen: Gut < 200 ms · Verbesserungswürdig 200–600 ms · Schlecht > 600 ms.',
        quickWin: 'Meta Pixel, GA4, TikTok auf Shopify Customer Events migrieren (Admin → Settings → Customer events). Ungenutzte Apps deinstallieren.'
      },
      FCP: {
        deepTip: 'FCP (First Contentful Paint) misst, wann der erste Inhalt (Text, Bild) auf dem Screen erscheint. Google-Schwellen: Gut < 1,8 s · Verbesserungswürdig 1,8–3 s · Schlecht > 3 s.',
        quickWin: 'Render-blocking Scripts & CSS identifizieren und async laden. Critical CSS direkt in `<head>` inline.'
      }
    };
    return map[key] || null;
  };

  SpeedTest.prototype.cwvCard = function (key, fullName, value, grade, desc, isCls) {
    var display = isCls ? value.toFixed(3) : this.formatMs(value);
    var labels = { good: 'Gut', ni: 'Verbesserungsbedarf', poor: 'Schlecht' };
    var ctx = this.cwvContext(key);
    var tipIcon = ctx ? '<span class="stf-tip" data-tip="' + this.escape(ctx.deepTip) + '" aria-label="' + key + ' erklärt" tabindex="0">\u24D8</span>' : '';
    var quickWin = '';
    if (ctx && grade !== 'good') {
      var qwFormatted = this.escape(ctx.quickWin).replace(/`([^`]+)`/g, '<code>$1</code>');
      quickWin =
        '<div class="stf-cwv-quickwin">' +
          '<div class="stf-cwv-quickwin-label">Quick Win</div>' +
          '<div class="stf-cwv-quickwin-text">' + qwFormatted + '</div>' +
        '</div>';
    }
    return '' +
      '<div class="stf-cwv-card stf-grade-' + grade + '">' +
        '<div class="stf-cwv-head">' +
          '<span class="stf-cwv-key">' + key + tipIcon + '</span>' +
          '<span class="stf-cwv-badge">' + labels[grade] + '</span>' +
        '</div>' +
        '<div class="stf-cwv-value">' + display + '</div>' +
        '<div class="stf-cwv-full">' + fullName + '</div>' +
        '<div class="stf-cwv-desc">' + desc + '</div>' +
        '<div class="stf-cwv-bar">' + this.cwvBarSegs(grade) + '</div>' +
        quickWin +
      '</div>';
  };

  SpeedTest.prototype.formatActionText = function (text) {
    var self = this;
    var lines = text.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
    if (lines.length <= 1) {
      return self.escape(text).replace(/`([^`]+)`/g, '<code>$1</code>').replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    }
    return '<ol class="stf-action-list">' + lines.map(function (l) {
      var clean = l.replace(/^\d+\.\s*/, '');
      return '<li>' + self.escape(clean).replace(/`([^`]+)`/g, '<code>$1</code>').replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>') + '</li>';
    }).join('') + '</ol>';
  };

  SpeedTest.prototype.insightCard = function (o, idx) {
    var interp = o.interpretation || {
      title: o.title, plain: (o.description || '').split('.')[0] + '.',
      action: 'Detaillierte Analyse durch unser Team im Strategiegespräch.',
      difficulty: 'Medium', category: 'mixed'
    };
    var catLabel = CATEGORY_LABELS[interp.category] || 'Gemischt';
    var catIcon = ICONS[interp.category] || ICONS.mixed;
    var effectiveMs = o.savingsMs || o.estimatedSavingsMs || 0;
    var isEstimated = !o.savingsMs && o.estimatedSavingsMs > 0;
    var savingsSec = effectiveMs > 0 ? (isEstimated ? '~' : '') + this.formatSavings(effectiveMs) : '';
    var bytes = o.savingsBytes > 0 ? this.formatBytes(o.savingsBytes) : '';
    var diffClass = 'stf-tag-diff-' + interp.difficulty.toLowerCase();
    var actionFormatted = this.formatActionText(interp.action);
    var plainFormatted = this.escape(interp.plain).replace(/`([^`]+)`/g, '<code>$1</code>').replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    var rank = String(idx + 1).padStart(2, '0');

    var quickTipIcon = interp.quickTip ?
      '<span class="stf-tip" data-tip="Quick-Win: ' + this.escape(interp.quickTip) + '" aria-label="Quick-Win-Info" tabindex="0">\u24D8</span>' : '';

    return '' +
      '<details class="stf-insight"' + (idx < 3 ? ' open' : '') + '>' +
        '<summary class="stf-insight-head">' +
          '<span class="stf-insight-rank">#' + rank + '</span>' +
          '<span class="stf-insight-cat-icon" aria-hidden="true">' + catIcon + '</span>' +
          '<div class="stf-insight-title-wrap">' +
            '<div class="stf-insight-title">' + this.escape(interp.title) + quickTipIcon + '</div>' +
            '<div class="stf-insight-meta">' +
              '<span class="stf-tag ' + diffClass + '">' + interp.difficulty + '</span>' +
              '<span class="stf-tag stf-tag-cat">' + catLabel + '</span>' +
              (savingsSec ? '<span class="stf-tag stf-tag-saving">↓ ' + savingsSec + '</span>' : '') +
            '</div>' +
          '</div>' +
          '<span class="stf-insight-chev" aria-hidden="true">' +
            '<svg viewBox="0 0 14 14" fill="none"><path d="M3 5l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</span>' +
        '</summary>' +
        '<div class="stf-insight-body">' +
          '<div class="stf-insight-row"><div class="stf-insight-row-label">Was das bedeutet</div><div class="stf-insight-row-text">' + plainFormatted + '</div></div>' +
          '<div class="stf-insight-row"><div class="stf-insight-row-label">So fixen wir das</div><div class="stf-insight-row-text">' + actionFormatted + '</div></div>' +
        '</div>' +
      '</details>';
  };

  SpeedTest.prototype.buildDualImpactHTML = function () {
    var crIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17l6-6 4 4 7-7"/><path d="M14 8h6v6"/></svg>';
    var adsIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L4 9v6l7 4"/><path d="M11 5l9 3v8l-9 3"/><path d="M11 5v14"/></svg>';

    var html = '';
    html += '<div class="stf-section">';
    html +=   this.chapterRow('05 / Mechanism', '', 'Warum Speed dein größter Hebel ist');
    html +=   '<div class="stf-section-head">';
    html +=     '<h2 class="stf-section-title">Speed wirkt <em>doppelt</em>.</h2>';
    html +=     '<p class="stf-section-sub">Jede Millisekunde, die du einsparst, trifft gleichzeitig auf zwei Hebel: direkt auf die Conversion Rate im Shop — und indirekt auf die Performance deiner Paid-Ads-Kanäle.</p>';
    html +=   '</div>';
    html +=   '<div class="stf-dual-impact">';

    html +=     '<div class="stf-impact-col stf-impact-col-cr">';
    html +=       '<div class="stf-impact-col-head">';
    html +=         '<div class="stf-impact-col-icon">' + crIcon + '</div>';
    html +=         '<div>';
    html +=           '<div class="stf-impact-col-label">Direkt · Shop</div>';
    html +=           '<div class="stf-impact-col-title">Auf deine Conversion Rate</div>';
    html +=         '</div>';
    html +=       '</div>';
    html +=       '<ul class="stf-impact-col-list">';
    html +=         '<li><span><strong>53% der Mobile-User</strong> brechen ab, wenn eine Seite länger als 3 Sekunden lädt — jeder Abbrecher war eine bezahlte Traffic-Akquise. (Google)</span></li>';
    html +=         '<li><span><strong>Deloitte 2020</strong>: 0,1 Sek. schnelleres LCP = +8,4% Conversion Rate im Retail. Kein anderer Hebel bewegt die CR so messbar wie Speed.</span></li>';
    html +=         '<li><span><strong>Checkout-Abbruch</strong> korreliert nahezu linear mit Cart-Page-Speed — 90% aller Warenkorb-Abbrüche haben ihre Ursache im Funnel davor, nicht in Preis/Versand.</span></li>';
    html +=         '<li><span><strong>Mobile Shopper</strong> haben im Schnitt 10 Sekunden Geduld nach Ad-Klick. Wenn LCP >3 s: die Hälfte ist weg, bevor dein USP sichtbar wird.</span></li>';
    html +=       '</ul>';
    html +=     '</div>';

    html +=     '<div class="stf-impact-col stf-impact-col-ads">';
    html +=       '<div class="stf-impact-col-head">';
    html +=         '<div class="stf-impact-col-icon">' + adsIcon + '</div>';
    html +=         '<div>';
    html +=           '<div class="stf-impact-col-label">Indirekt · Paid Ads</div>';
    html +=           '<div class="stf-impact-col-title">Auf Meta, Google &amp; TikTok</div>';
    html +=         '</div>';
    html +=       '</div>';
    html +=       '<ul class="stf-impact-col-list">';
    html +=         '<li><span><strong>Landing Page Experience</strong> ist ein direkter Ranking-Faktor in Meta&rsquo;s Delivery-System. Langsame Seiten = Algorithm verschiebt Budget auf Konkurrenz — bei identischem Creative.</span></li>';
    html +=         '<li><span><strong>CPMs steigen 20–40%</strong> bei LCP >3 s — Meta kompensiert die schlechtere Experience durch teurere Impressionen, um die gleiche Zielgruppe zu erreichen.</span></li>';
    html +=         '<li><span><strong>Quality Score in Google Ads</strong> fällt bei langsamen Landing Pages um 2–4 Punkte — der Unterschied zwischen profitabler Skalierung und verbranntem Budget.</span></li>';
    html +=         '<li><span><strong>Retargeting-Pools schrumpfen</strong>: wer vor dem View-Content bounced, landet nicht in der Custom Audience. Dein Funnel verliert auf jeder Stufe ein Stück Reichweite.</span></li>';
    html +=       '</ul>';
    html +=     '</div>';

    html +=   '</div>';
    html += '</div>';
    return html;
  };

  SpeedTest.prototype.buildTimelineHTML = function (o) {
    var self = this;
    var html = '';
    html += '<div class="stf-section">';
    html +=   this.chapterRow('02 / Visual', '', 'Wie dein Shop tatsächlich lädt');
    html +=   '<div class="stf-section-head">';
    html +=     '<h2 class="stf-section-title">Was der <em>User sieht</em>.</h2>';
    html +=     '<p class="stf-section-sub">Der Filmstrip zeigt dir Sekunde für Sekunde, wie deine Seite auf einem mittelklasse Mobile-Gerät lädt. Jede leere Frame = ein potenzieller Abbrecher.</p>';
    html +=   '</div>';
    if (o.shotsMobile.filmstrip.length > 0) {
      html += '<div class="stf-filmstrip">';
      o.shotsMobile.filmstrip.forEach(function (frame, i) {
        var t = (frame.timing / 1000).toFixed(1);
        html += '<div class="stf-film-frame">' +
                  '<div class="stf-film-img"><img src="' + frame.data + '" alt="Frame ' + (i+1) + '" loading="lazy"/></div>' +
                  '<div class="stf-film-time">' + t + ' s</div>' +
                '</div>';
      });
      html += '</div>';
    }
    html += '</div>';
    return html;
  };

  SpeedTest.prototype.verdictText = function (mobile, desktop) {
    if (mobile < 50 && desktop < 50) return 'Kritisch. Dein Shop verliert auf Mobile und Desktop massiv Umsatz durch Performance-Probleme.';
    if (mobile < 50) return 'Mobile ist kritisch. Die meisten Shopify-Shops machen >70% Umsatz auf Mobile — hier liegt dein größter Hebel.';
    if (mobile < 75) return 'Optimierbar. Mit gezielten Fixes kannst du den Mobile-Score schnell über 85 heben.';
    if (mobile < 90) return 'Solide Basis. Feintuning in den Top-Schwachstellen bringt dich auf 90+.';
    return 'Exzellent. Dein Shop gehört zu den Top-Performern. Nur noch Finetuning nötig.';
  };

  SpeedTest.prototype.buildResultsHTML = function (o) {
    var cta = this.ctaData;
    var revenue = this.defaults.revenue;
    var impact = this.calculateImpact(o.mobile.lcp, revenue);
    var self = this;
    var mGrade = this.scoreGrade(o.mobile.score);
    var dGrade = this.scoreGrade(o.desktop.score);
    var nowStr = new Date().toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }) +
      ' · ' + new Date().toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });

    var html = '';

    html += '<div class="stf-score-hero">';
    html +=   this.chapterRow('01 / Audit', '', 'Gescannt am ' + nowStr);
    html +=   '<div class="stf-score-url-row">Ziel: <strong>' + this.escape(o.url) + '</strong></div>';
    html +=   '<div class="stf-score-dual">';
    html +=     this.scoreCircleHTML('Mobile', o.mobile.score, mGrade);
    html +=     this.scoreCircleHTML('Desktop', o.desktop.score, dGrade);
    html +=   '</div>';
    html +=   '<div class="stf-score-verdict">' + this.escape(this.verdictText(o.mobile.score, o.desktop.score)) + '</div>';
    html += '</div>';

    if (o.shotsMobile && o.shotsMobile.filmstrip.length) {
      html += this.buildTimelineHTML(o);
    }

    html += '<div class="stf-section">';
    html +=   this.chapterRow('03 / Metrics', '', 'Mobile-Messung · Google Core Web Vitals');
    html +=   '<div class="stf-section-head">';
    html +=     '<h2 class="stf-section-title">Wie sich das <em>anfühlt</em>.</h2>';
    html +=     '<p class="stf-section-sub">Google misst nicht „die" Ladezeit — sondern <strong>vier konkrete Momente</strong>, in denen dein User entscheidet, ob er bleibt oder abbricht. Eine LCP von 15 Sekunden bedeutet z.B. nicht, dass die ganze Seite 15s braucht — sondern dass das größte sichtbare Element (meist das Hero-Bild) erst nach 15s fertig gerendert ist. Tap auf <span class="stf-tip-inline">ⓘ</span> für Details zu jeder Kennzahl.</p>';
    html +=   '</div>';
    html +=   '<div class="stf-cwv-grid">';
    html +=     this.cwvCard('LCP', 'Largest Contentful Paint', o.mobile.lcp, this.metricGrade('lcp', o.mobile.lcp), 'Wann dein größtes sichtbares Element fertig ist. Ziel: unter 2,5 s.');
    html +=     this.cwvCard('CLS', 'Cumulative Layout Shift', o.mobile.cls, this.metricGrade('cls', o.mobile.cls), 'Wie stark das Layout beim Laden springt. Ziel: unter 0,1.', true);
    html +=     this.cwvCard('TBT', 'Total Blocking Time', o.mobile.tbt, this.metricGrade('tbt', o.mobile.tbt), 'Wie lange der Browser blockiert ist. Ziel: unter 200 ms.');
    html +=     this.cwvCard('FCP', 'First Contentful Paint', o.mobile.fcp, this.metricGrade('fcp', o.mobile.fcp), 'Wann der erste Inhalt erscheint. Ziel: unter 1,8 s.');
    html +=   '</div>';
    html += '</div>';

    html += '<div class="stf-gated-content" data-stf-gated>';

    html += '<div class="stf-section">';
    html +=   this.chapterRow('04 / Insights', '', o.opportunities.length + ' Schwachstellen gefunden');
    html +=   '<div class="stf-section-head">';
    html +=     '<h2 class="stf-section-title">Deine Top-<em>Hebel</em>.</h2>';
    html +=     '<p class="stf-section-sub">Sortiert nach Impact. Jede Schwachstelle Shopify-spezifisch übersetzt — nicht das generische Lighthouse-Copy.</p>';
    html +=   '</div>';
    if (o.opportunities.length === 0) {
      html += '<div class="stf-empty">Dein Shop ist bereits solide optimiert — keine kritischen Hebel identifiziert.</div>';
    } else {
      var measuredMs = o.opportunities.reduce(function (sum, opp) { return sum + (opp.savingsMs || 0); }, 0);
      var estimatedMs = o.opportunities.reduce(function (sum, opp) { return sum + (opp.savingsMs ? 0 : (opp.estimatedSavingsMs || 0)); }, 0);
      var totalMs = measuredMs + estimatedMs;
      if (totalMs > 200) {
        var totalSec = this.formatSavings(totalMs);
        var totalParts = totalSec.split(' ');
        var prefix = estimatedMs > 0 ? '~' : '';
        var hintText = estimatedMs > 0
          ? 'Wenn wir alle ' + o.opportunities.length + ' Hebel umsetzen. Gemischt aus Lighthouse-Messwerten und konservativer Schätzung für Audits ohne Hard-ms (DOM-Größe, Third-Party-Scripts) — basierend auf deinem LCP/FCP/TBT-Gap. Überschneidungen berücksichtigt, <strong>im Schnitt wahrscheinlich in deinem Shop erreichbar</strong>.'
          : 'Wenn wir alle ' + o.opportunities.length + ' Hebel umsetzen. Überschneidungen berücksichtigt — <strong>im Schnitt wahrscheinlich in deinem Shop erreichbar</strong>.';
        html += '<div class="stf-total-savings">' +
          '<div>' +
            '<div class="stf-total-savings-label">Gesamtes Einsparpotenzial</div>' +
            '<div class="stf-total-savings-value"><em>−</em>' + prefix + totalParts[0] + ' <em>' + (totalParts[1] || 's') + '</em></div>' +
          '</div>' +
          '<div class="stf-total-savings-hint">' + hintText + '</div>' +
        '</div>';
      }
      html += '<div class="stf-insights">';
      o.opportunities.forEach(function (opp, idx) { html += self.insightCard(opp, idx); });
      html += '</div>';
    }
    html += '</div>';

    html += this.buildDualImpactHTML();

    html += '<div class="stf-section">';
    html +=   this.chapterRow('06 / Revenue', '', 'Impact-Modell · Deloitte 2020');
    html +=   '<div class="stf-impact-section">';
    html +=     '<div class="stf-section-head" style="margin-bottom: 24px;">';
    html +=       '<h2 class="stf-section-title">Was dich das <em>kostet</em>.</h2>';
    html +=       '<p class="stf-impact-intro">Basierend auf Industry-Benchmarks (<strong>Walmart: +2% Conversion pro 1 s</strong>; Amazon: +1% pro 100 ms; Deloitte 2020: +8,4% pro 0,1 s im Retail). Wir rechnen bewusst konservativ mit ~2% pro Sekunde Ladezeit-Verbesserung, mit Diminishing Returns ab 3 s und einem Cap bei 12% — damit die Zahl realistisch bleibt, nicht overselled.</p>';
    html +=     '</div>';
    html +=     '<div class="stf-calc">';
    html +=       '<label class="stf-calc-input">';
    html +=         '<span class="stf-calc-label">Monatlicher Umsatz</span>';
    html +=         '<div class="stf-calc-field"><input type="number" data-stf-revenue value="' + revenue + '" min="0" step="1000"> <span class="stf-calc-suffix">€ / Monat</span></div>';
    html +=       '</label>';
    html +=     '</div>';
    html +=     '<div class="stf-impact-row">';
    html +=       '<div class="stf-impact-card">';
    html +=         '<div class="stf-impact-label">LCP-Delta zu Target</div>';
    html +=         '<div class="stf-impact-value"><em>−</em>' + impact.improvementSec.toFixed(1) + ' <em>s</em></div>';
    html +=         '<div class="stf-impact-sub">' + this.formatMs(o.mobile.lcp) + ' → 2.0 s Ziel</div>';
    html +=       '</div>';
    html +=       '<div class="stf-impact-card">';
    html +=         '<div class="stf-impact-label">Conversion-Lift</div>';
    html +=         '<div class="stf-impact-value"><em>+</em>' + impact.convLiftPct.toFixed(1) + '<em>%</em></div>';
    html +=         '<div class="stf-impact-sub">Konservative Schätzung</div>';
    html +=       '</div>';
    html +=       '<div class="stf-impact-card stf-impact-highlight">';
    html +=         '<div class="stf-impact-label">Ungenutztes Umsatzpotenzial</div>';
    html +=         '<div class="stf-impact-value" data-stf-impact-monthly>' + this.formatEuro(impact.monthlyUplift) + '</div>';
    html +=         '<div class="stf-impact-sub" data-stf-impact-yearly>' + this.formatEuro(impact.yearlyUplift) + ' pro Jahr · basierend auf deinem aktuellen Umsatz</div>';
    html +=       '</div>';
    html +=     '</div>';
    html +=   '</div>';
    html += '</div>';

    html += '<div class="stf-cta-section">';
    html +=   '<div class="stf-cta-inner">';
    if (cta.eyebrow) html += '<div class="stf-cta-eyebrow"><span class="stf-eyebrow-dot"></span>' + this.escape(cta.eyebrow) + '</div>';
    html +=     '<h2 class="stf-cta-headline">' + cta.headline + '</h2>';
    html +=     '<p class="stf-cta-sub">' + this.escape(cta.subtext) + '</p>';
    // Priorisierung: explizite Calendly-URL → Auto-Detection auf Button-URL → Plain-Link → disabled
    var calendlyUrl = cta.calendlyUrl || (this.isCalendlyUrl(cta.buttonUrl) ? cta.buttonUrl : '');
    if (calendlyUrl) {
      html += '<button type="button" class="stf-cta-button" data-stf-calendly data-calendly-url="' + this.escape(calendlyUrl) + '">' + this.escape(cta.buttonText) + ' <span class="stf-cta-arrow">→</span></button>';
    } else if (cta.buttonUrl) {
      html += '<a href="' + this.escape(cta.buttonUrl) + '" class="stf-cta-button">' + this.escape(cta.buttonText) + ' <span class="stf-cta-arrow">→</span></a>';
    } else {
      html += '<button type="button" class="stf-cta-button" disabled>' + this.escape(cta.buttonText) + '</button>';
    }
    html +=     '<div class="stf-cta-footnote">15 Min. Call · Kostenlos · Keine Verpflichtung</div>';
    html +=   '</div>';
    html += '</div>';

    html += '<div class="stf-rerun"><button type="button" class="stf-rerun-btn" data-stf-rerun>Andere URL analysieren</button></div>';

    html += '</div>';

    if (this.gateConfig.enabled) {
      html += '<div class="stf-gate-overlay" data-stf-gate hidden>';
      html +=   '<div class="stf-gate-card">';
      html +=     '<div class="stf-gate-icon" aria-hidden="true">' +
                    '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
                      '<rect x="4" y="11" width="16" height="10" rx="2"/>' +
                      '<path d="M8 11V7a4 4 0 0 1 8 0v4"/>' +
                    '</svg>' +
                  '</div>';
      html +=     '<h3 class="stf-gate-headline">' + this.escape(this.gateConfig.headline) + '</h3>';
      if (this.gateConfig.subtext) {
        html +=   '<p class="stf-gate-subtext">' + this.escape(this.gateConfig.subtext) + '</p>';
      }
      html +=     '<form class="stf-gate-form" data-stf-gate-form novalidate>';
      html +=       '<input type="email" name="email" placeholder="' + this.escape(this.gateConfig.placeholder) + '" required autocomplete="email" data-stf-gate-email>';
      html +=       '<div class="stf-gate-hint" data-stf-gate-hint hidden></div>';
      html +=       '<input type="tel" name="phone" placeholder="' + this.escape(this.gateConfig.phonePlaceholder) + '" required autocomplete="tel" inputmode="tel" data-stf-gate-phone>';
      html +=       '<div class="stf-gate-error" data-stf-gate-error hidden></div>';
      html +=       '<button type="submit">' + this.escape(this.gateConfig.button) + '</button>';
      html +=     '</form>';
      if (this.gateConfig.trust) {
        html +=   '<div class="stf-gate-trust">' + this.escape(this.gateConfig.trust) + '</div>';
      }
      html +=   '</div>';
      html += '</div>';
    }

    return html;
  };

  SpeedTest.prototype.bindImpactCalc = function (currentLcp) {
    var self = this;
    var input = this.results.querySelector('[data-stf-revenue]');
    if (!input) return;
    var monthly = this.results.querySelector('[data-stf-impact-monthly]');
    var yearly = this.results.querySelector('[data-stf-impact-yearly]');
    var update = function () {
      var rev = parseFloat(input.value) || 0;
      var impact = self.calculateImpact(currentLcp, rev);
      if (monthly) monthly.textContent = self.formatEuro(impact.monthlyUplift);
      if (yearly) yearly.textContent = self.formatEuro(impact.yearlyUplift) + ' pro Jahr · basierend auf deinem aktuellen Umsatz';
    };
    input.addEventListener('input', update);

    var rerun = this.results.querySelector('[data-stf-rerun]');
    if (rerun) rerun.addEventListener('click', function () { self.reset(); self.urlInput.focus(); });
  };

  var instances = [];
  document.querySelectorAll('[data-speed-test]').forEach(function (el) {
    instances.push(new SpeedTest(el));
  });

  // Dev/QA-API für Console-Testing der Bait-Mechanik. Schädigt nichts in Prod —
  // ruft nur Methoden auf die der User durch normale Interaction sowieso erreichen würde.
  // DevTools → Console:
  //   __stf.testBait('hero-button')          // simuliert Klick auf glowing Button
  //   __stf.testBait('gate-exit')            // simuliert Email-Gate dismiss
  //   __stf.testBait('mobile-chrome-expand') // simuliert IG/Mobile-Chrome aufgehen
  //   __stf.resetBait()                      // session flag clearen → Trigger feuern wieder
  //   __stf.resetGate()                      // localStorage flag clearen → Email-Gate erscheint wieder
  //   __stf.simulateChromeExpand()           // dispatched echtes visualViewport resize event
  //   __stf.instances                        // alle SpeedTest instances am Page
  window.__stf = {
    instances: instances,
    testBait: function (trigger) {
      var st = instances[0];
      if (!st) { console.warn('[__stf] no SpeedTest instance'); return; }
      try { sessionStorage.removeItem('stf_bait_shown'); } catch (e) {}
      st._baitShown = false;
      st.showBaitPopup(trigger || 'hero-button');
    },
    resetBait: function () {
      try {
        sessionStorage.removeItem('stf_bait_shown');
        sessionStorage.removeItem('stf_bait_enrich_pending');
        sessionStorage.removeItem('stf_bait_enrich_email');
      } catch (e) {}
      instances.forEach(function (st) { st._baitShown = false; });
      console.log('[__stf] bait reset — triggers will fire again');
    },
    resetGate: function () {
      try { localStorage.removeItem('stf_gate_passed'); } catch (e) {}
      console.log('[__stf] gate reset — Email-Gate will show on next test');
    },
    simulateChromeExpand: function () {
      // Faked resize-event auf visualViewport um Mobile-Chrome-Trigger zu testen
      if (!window.visualViewport) { console.warn('[__stf] no visualViewport API'); return; }
      console.log('[__stf] simulating chrome-expand. If you submitted bait already, also call __stf.resetBait() first.');
      var ev = new Event('resize');
      // Hack: temporär die Höhe-Property überschreiben (read-only normalerweise)
      var origHeight = window.visualViewport.height;
      try {
        Object.defineProperty(window.visualViewport, 'height', {
          configurable: true,
          get: function () { return origHeight - 100; }
        });
        window.visualViewport.dispatchEvent(ev);
      } catch (e) {
        console.warn('[__stf] could not override visualViewport.height — trigger directly:', e);
        instances[0] && instances[0].showBaitPopup('mobile-chrome-expand');
      }
    }
  };
})();
